/* Banky Nieuw WP2.1: gedrag van de koopbox op de productpagina (PLAN.md #17, #19, #20, #28, #31).
   Geladen door sections/main-product.liquid (defer). Werkt met Halo's eigen formulier en gebeurtenissen, zonder eigen
   winkelwagenlogica naast die van het thema:
     - variantwissel (variant:change op het productformulier): beschikbaarheid van de koopbox (data-beschikbaar), de
       leverregel met aftelling in de servicekaart (alleen bij een beschikbare variant), Direct afrekenen, het blok
       #alternatieven, de sticky balk en het hoofdproduct van "Maak het compleet";
     - "Maak het compleet" (<banky-complete>, snippet banky-complete-addons): vinkjes en keuzelijsten, lopend totaal
       ("Totaal" en "Bespaar", van-prijzen tegen wat de knop toevoegt), en één keer toevoegen met /cart/add.js (items[]),
       met dezelfde gebeurtenissen als Halo's productformulier (variant:add opent de lade, cart:change ververst hem);
       sinds 06-10-2026 met de actie 2e artikel (window.bankyDeal: rekenregel van Shopify, labels, één prijsregel, één
       aanvuller vooraf aangevinkt, meting zonder persoonsgegevens);
     - sticky balk (snippet banky-sticky-bar): tabs alleen als hun doel bestaat, actieve tab volgt het scrollen, op
       desktop direct onder de zwevende kop en met dezelfde CSS-overgang mee als die wegschuift of terugkomt (sinds 21-10-2026);
     - toevoegen vanuit de sticky balk of het koopvak: de lade gaat meteen open terwijl Shopify toevoegt (snelleLade);
       Halo vult hem zodra het antwoord er is;
     - titel: vaste spatie tussen getal en eenheid ("30.000 mAh"), zodat de gebalanceerde H1 ze niet scheidt.
   Alles stil bij prefers-reduced-motion (geen vloeiend scrollen). */
(() => {
  if (window.bankyProduct) return;
  window.bankyProduct = {versie: 1};

  const wortel = () => ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');
  const vloeiend = () => !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const perForm = (selector, id) => document.querySelectorAll(selector.replace('%', CSS.escape(id)));

  // Geld zoals Shopify's money_format ("€{{amount_with_comma_separator}}"): "€59,95", duizendtallen met een punt.
  const geld = (centen, formaat) => {
    const n = Math.round(Number(centen) || 0) / 100;
    const [heel, deel] = Math.abs(n).toFixed(2).split('.');
    const komma = (n < 0 ? '-' : '') + heel.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + deel;
    const punt = (n < 0 ? '-' : '') + heel.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + deel;
    const f = formaat || '€{{amount_with_comma_separator}}';
    return f.replace(/{{\s*amount_with_comma_separator\s*}}/, komma).replace(/{{\s*amount\s*}}/, punt).replace(/{{\s*amount_no_decimals_with_comma_separator\s*}}/, komma.replace(/,\d\d$/, ''));
  };

  /* ---- Variantwissel in de koopbox ---------------------------------------------------------------------------- */
  const koopboxen = () => document.querySelectorAll('[data-banky-koopbox][data-form]');
  // WP r1-zoek-kar (Geert 16-10 punt 5): "Bespaar €x (y%)" in de koopbox rekent mee met de gekozen variant (snippets/
  // price-list.liquid, data-banky-bespaar); procent naar beneden afgerond, zoals in de sticky balk.
  function zetBespaar(formId, variant) {
    perForm('[data-banky-bespaar="%"]', formId).forEach(el => {
      const bedrag = variant && variant.compare_at_price > variant.price ? variant.compare_at_price - variant.price : 0;
      if (!bedrag) { el.style.display = 'none'; el.textContent = ''; return; }
      const pct = Math.floor(bedrag * 100 / variant.compare_at_price);
      const formaat = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat;
      el.textContent = (el.dataset.sjabloon || 'Bespaar {bedrag} ({pct}%)').replace('{bedrag}', geld(bedrag, formaat)).replace('{pct}', pct);
      el.style.display = '';
    });
  }
  function zetBeschikbaar(formId, variant) {
    zetBespaar(formId, variant);
    const beschikbaar = !!(variant && variant.available);
    perForm('[data-banky-koopbox][data-form="%"]', formId).forEach(box => {
      box.dataset.beschikbaar = String(beschikbaar);
      box.querySelectorAll('.banky-assurances__row--levering').forEach(rij => {
        rij.dataset.beschikbaar = String(beschikbaar);
        rij.hidden = !beschikbaar;
        if (beschikbaar && typeof window.bankyDelivery === 'function') window.bankyDelivery(rij.parentNode);
      });
      box.querySelectorAll('[data-banky-alternatieven]').forEach(el => { el.hidden = beschikbaar; });
      if (beschikbaar) box.querySelectorAll('[data-banky-bis-terugval]').forEach(el => { el.hidden = true; });
      bisVariant(box, variant);
      box.querySelectorAll('.banky-koopbox__direct').forEach(knop => { knop.hidden = !beschikbaar; knop.disabled = !beschikbaar; });
    });
    perForm('[data-banky-sticky][form="%"]', formId).forEach(balk => {
      balk.dataset.beschikbaar = String(beschikbaar);
      const knop = balk.querySelector('[data-banky-sticky-knop]'), alt = balk.querySelector('[data-banky-sticky-alternatieven]');
      if (knop) { knop.hidden = !beschikbaar && !!alt; knop.disabled = !beschikbaar; }
      if (alt) alt.hidden = beschikbaar;
      balk.querySelectorAll('[data-banky-delivery]').forEach(regel => {
        regel.dataset.beschikbaar = String(beschikbaar);
        regel.hidden = !beschikbaar;
        if (beschikbaar && typeof window.bankyDelivery === 'function') window.bankyDelivery(regel.parentNode);
      });
    });
    perForm('banky-complete[data-form="%"]', formId).forEach(blok => blok.zetHoofd(variant));
  }
  // WP r1-zoek-kar (punt 10): een chip "Wel op voorraad in" kiest die uitvoering in de koopbox (Halo's variantkiezer doet de
  // rest: prijs, voorraad, alternatieven weer dicht). Zonder koopbox of zonder passende keuze gewoon de link (?variant=).
  document.addEventListener('click', e => {
    const chip = e.target.closest && e.target.closest('[data-banky-kies-variant]');
    if (!chip) return;
    const box = chip.closest('[data-banky-koopbox][data-form]');
    const formId = box && box.dataset.form;
    const keuze = formId && [...document.querySelectorAll(`input[type="radio"][name="option1"][form="${CSS.escape(formId)}"]`)].find(i => i.value === chip.dataset.optie);
    if (!keuze) return;
    e.preventDefault();
    keuze.click();
    const label = keuze.id && document.querySelector(`label[for="${CSS.escape(keuze.id)}"]`);
    if (label) { label.scrollIntoView({block: 'center', behavior: vloeiend() ? 'smooth' : 'auto'}); keuze.focus({preventScroll: true}); }
  });
  function volgFormulieren() {
    const gezien = new Set();
    koopboxen().forEach(box => {
      const id = box.dataset.form;
      if (!id || gezien.has(id)) return;
      gezien.add(id);
      const form = document.forms[id] || document.getElementById(id);
      if (!form || form.dataset.bankyProduct) return;
      form.dataset.bankyProduct = '1';
      form.addEventListener('variant:change', e => zetBeschikbaar(id, e.detail && e.detail.variant));
    });
  }

  /* ---- Actie 2e artikel: rekenkern ---------------------------------------------------------------------------- */
  // Upsell 2e artikel (06-10-2026; design/upsell-2e-artikel/rekenkern.mjs en BOUWSPEC.md). De automatische korting
  // "koop 1, krijg 1 met x% korting" (NAJAARSDEALS) rekent zo (51 echte winkelwagens op banky.nl, 0 afwijkingen): van de n
  // stuks in de winkelwagen krijgen de floor(n/2) goedkoopste stuks x% op hun actieprijs, afgerond op centen; bij gelijke
  // prijs het laatst toegevoegde stuk. Stuk: {id, p (actieprijs in centen), c (van-prijs), volg (later is hoger), kort, v}.
  // Sinds 21-10 (toets max-model: 43 live winkelwagens, per variant): bij gelijke prijs eerst het stuk van de variant met het
  // kleinste aantal in de winkelwagen, pas bij gelijk aantal het laatst toegevoegde. v is het variant-id (stukken met
  // dezelfde v zijn één variant, ook over gesplitste regels); zonder v telt het id.
  // De functies deal, koopbox, prijsregel en kiesVooraf zijn letterlijk die van rekenkern.mjs (getoetst op 17 koopbox-
  // proeven van live en 20.000 willekeurige gevallen); snippets/banky-complete-addons.liquid rekent de eerste stand met
  // dezelfde regel (banky-deal-som).
  // WP deal-bundel (Geert 19-10-2026: "op bundels word geen 20% voor 2e artikel toegepast"): een stuk met g === false (een
  // bundel, krijgtVanType hieronder en snippets/banky-deal-geldt.liquid) telt mee als eerste artikel, maar krijgt nooit zelf
  // korting: de k = min(stukken die korting kunnen krijgen, floor(n/2)) goedkoopste daarvan krijgen x%. Zonder bundels is
  // dat de regel hierboven.
  // Brillen (Geert 20-10-2026: "dus bril + product of product + bril is wel 2e 20%. alleen bij 2 brillen geld de bundel"):
  // een bril (bril: true, brilVanType) kan de 20% krijgen. Met paar > 0 (het voordeel per paar brillen, snippets/
  // banky-bril-paar.liquid) rekent deal ook de duoprijs. Gemeten op banky.nl 20-10 (156 winkelwagens, 0 afwijkingen;
  // snippets/banky-deal-som.liquid rekent hetzelfde): Y zijn de k goedkoopste stukken die korting kunnen krijgen, X de k
  // duurste van de rest; het j-de goedkoopste Y hoort bij X[k-1-j]. De duoprijs neemt 2 x floor(B/2) brillen: eerst brillen
  // die in geen paar zitten (niet in Y en niet in X), dan de brillen in Y (goedkoopste eerst), dan de brillen in X (vanaf
  // X[k-1]); elk paar met zo'n duobril vervalt. duo = paren x paar. Zonder paar brillen is het precies de regel hierboven.
  // Prijsgroepen (Geert 20-10-2026: "ik wil trouwens wel als je 2x hetzelfde product toevoegt dat de korting word toegepast
  // op dat zelfde product mocht het 3e product goedkoper zijn" en "2 extra producten voor dezelfde prijs mogen die korting
  // naar elkaar verrekenen dat is prima ook goed voor conversie"; /Users/geert/banky-r1-werk/deal-prijsgroepen/plan.md). Per
  // prijs staat in Shopify een automatische korting "2e stuk zelfde prijs €x" (koop 1, krijg 1 met x% binnen de slimme
  // collectie van die prijs; geen bundels, geen bril), niet combineerbaar met productkortingen. Lid is elk stuk waarvan het
  // product een variant met die prijs heeft (groepVan: x.gr, anders de eigen prijs). Gemeten op banky.nl 20-10 avond (13
  // winkelwagens in deal-prijsgroepen/metingen-nc.md en 16 nieuwe in scratchpad max-model/bouwer; 0 afwijkingen, ook per
  // stuk): Shopify kiest de hoogste van (a) NAJAARSDEALS met de duoprijs zoals hierboven (de x% en de duoprijs samen) en (b)
  // elke groep afzonderlijk (groepen combineren niet met elkaar en niet met (a)). Waarde van een groep: de x% op de floor(m/2)
  // goedkoopste van zijn m leden (bij gelijke prijs het laatst toegevoegde). Bij gelijke waarde wint de groep, en van twee
  // groepen met gelijke waarde de duurste. Wint een groep, dan krijgen alleen zijn stukken korting en is duo 0. Zonder paar
  // in dezelfde groep is het precies de regel hierboven. groepen false: zonder prijsgroepen (thema-instelling
  // banky_deal_groepen uit). snippets/banky-deal-som.liquid rekent hetzelfde (10.000 willekeurige winkelwagens gelijk).
  // Uitvoer: tot (de x% van NAJAARSDEALS of van de groep die wint), op (per id, goedkoop naar duur), duo, en paren (per stuk
  // met korting het id, het bedrag en de groep, leeg voor NAJAARSDEALS; voor de demo-winkelwagen van de preview).
  function groepVan(x) {
    if (x.g === false || x.bril) return [];
    if (Array.isArray(x.gr)) return x.gr.map(String);
    if (x.gr != null && x.gr !== '') return String(x.gr).split('.').filter(Boolean);
    return [String(x.p)];
  }
  function deal(stukken, pct = 20, paar = 0, groepen = true) {
    const r = p => Math.round(p * pct / 100);
    const variant = x => (x.v != null && x.v !== '' ? String(x.v) : String(x.id));
    // Duo (Geert 21-10-2026, verborgen bundel van 2 stuks; snippets/banky-duo-paar.liquid): heeft een stuk x.d (zijn variant
    // heeft een geldige bundel), dan worden alle stukken van die variant twee aan twee die bundel (ook stukken zonder d, zoals
    // de winkelwagen uit /cart.js), het oudste stuk blijft los bij een oneven aantal. Een paar krijgt vast de x% op één stuk
    // (het nieuwste van het paar, in tot en op) en doet niet mee aan NAJAARSDEALS, de duoprijs en de groepen: de bundel zit
    // niet in "klant koopt" en in geen groep. Zonder d precies het model hieronder. snippets/banky-deal-som.liquid rekent
    // hetzelfde (zevende veld d), ook de volgorde: eerst de paren, per variant in de volgorde van het eerste stuk met d.
    const vast = [];
    if (stukken.some(x => x.d)) {
      const perV = new Map();
      stukken.forEach(x => { if (x.d && !perV.has(variant(x))) perV.set(variant(x), []); });
      stukken.forEach(x => { const v = variant(x); if (perV.has(v)) perV.get(v).push(x); });
      const weg = new Set();
      for (const lijst of perV.values()) {
        const s = [...lijst].sort((a, b) => a.volg - b.volg);
        const inPaar = s.slice(s.length % 2);
        for (let i = 0; i + 1 < inPaar.length; i += 2) { weg.add(inPaar[i]); weg.add(inPaar[i + 1]); vast.push({y: inPaar[i + 1], groep: 'duo'}); }
      }
      stukken = stukken.filter(x => !weg.has(x));
    }
    // Bij gelijke prijs eerst het stuk van de variant met het kleinste aantal in de winkelwagen, dan het laatst toegevoegde
    // (toets 21-10: 43 live winkelwagens per variant verklaard, "laatst toegevoegd" alleen 35; de 156 van bril-duo-2010 ook).
    // Variant: x.v (variant-id), anders het id; aantal = de stukken met dezelfde variant in deze winkelwagen.
    const tel = new Map();
    stukken.forEach(x => tel.set(variant(x), (tel.get(variant(x)) || 0) + 1));
    const n = x => tel.get(variant(x));
    const goedkoop = (a, b) => a.p - b.p || n(a) - n(b) || b.volg - a.volg;
    const S = [...stukken].sort((a, b) => b.p - a.p || n(b) - n(a) || a.volg - b.volg);
    // (a) NAJAARSDEALS met de duoprijs: het model zonder prijsgroepen. Y de k goedkoopste stukken die korting kunnen krijgen,
    // elk met als koper het duurste stuk buiten Y dat nog vrij is (het j-de goedkoopste Y hoort bij X[k-1-j]).
    const kan = stukken.filter(x => x.g !== false).sort(goedkoop);
    const k = Math.min(kan.length, Math.floor(stukken.length / 2));
    const Y = kan.slice(0, k), inY = new Set(Y), bezet = new Set(), eigen = [];
    for (const y of [...Y].reverse()) {
      const x = S.find(z => z !== y && !bezet.has(z) && !inY.has(z));
      if (!x) continue;
      bezet.add(x); bezet.add(y); eigen.push({x, y, groep: ''});
    }
    // De duoprijs neemt 2 x floor(B/2) brillen: vrije brillen, dan brillen in Y, dan brillen als koper; paren met zo'n bril vervallen.
    const brillen = paar > 0 ? S.filter(x => x.bril) : [];
    const paren = Math.floor(brillen.length / 2);
    const opY = [...eigen].sort((a, b) => goedkoop(a.y, b.y));
    const inPaar = new Set(eigen.flatMap(q => [q.x, q.y]));
    const volgorde = [...brillen.filter(x => !inPaar.has(x)), ...opY.filter(q => q.y.bril).map(q => q.y), ...opY.filter(q => q.x.bril).map(q => q.x)];
    const D = new Set(volgorde.slice(0, 2 * paren));
    let uit = eigen.filter(q => !D.has(q.x) && !D.has(q.y));
    let duo = paren * paar;
    // (b) Prijsgroepen (meting 20-10 avond, metingen-nc.md): elke groep los, niet samen met (a) en niet met elkaar. Waarde van
    // groep L: de floor(m/2) goedkoopste van zijn m leden krijgen x%. Shopify kiest de hoogste; bij gelijke waarde wint de groep,
    // en van twee groepen met gelijke waarde de duurste (L hoger).
    if (groepen) {
      const waardeA = uit.reduce((t, q) => t + r(q.y.p), 0) + duo;
      const leden = new Map();
      S.forEach(x => groepVan(x).forEach(L => { if (!leden.has(L)) leden.set(L, []); leden.get(L).push(x); }));
      let beste = null;
      for (const [L, lijst] of leden) {
        if (lijst.length < 2) continue;
        const YL = [...lijst].sort(goedkoop).slice(0, Math.floor(lijst.length / 2));
        const w = YL.reduce((t, y) => t + r(y.p), 0);
        if (!beste || w > beste.w || (w === beste.w && Number(L) > Number(beste.L))) beste = {L, Y: YL, w};
      }
      if (beste && beste.w > 0 && beste.w >= waardeA) {
        uit = beste.Y.map(y => ({y, groep: beste.L}));
        duo = 0;
      }
    }
    uit.sort((a, b) => goedkoop(a.y, b.y));
    uit = [...vast, ...uit];
    const op = new Map();
    let tot = 0;
    for (const q of uit) {
      const kk = r(q.y.p);
      tot += kk; op.set(q.y.id, (op.get(q.y.id) || 0) + kk);
    }
    return {tot, op, duo, paren: uit.map(q => ({id: q.y.id, korting: r(q.y.p), groep: q.groep}))};
  }
  const som = (l, f) => l.reduce((a, x) => a + f(x), 0);
  // inPct (koopbox, BESLUITEN 14b): ook met deal "Bespaar x%" tegen de van-prijs, zoals zonder deal.
  // Een bril (r.bril) nooit doorgestreept (20-10-2026: nieuw product zonder eerdere prijs; banky-prijsregel zonder_van).
  function prijsregel(r, dealprijs = null, inPct = false) {
    const nu = dealprijs ?? r.p;
    const door = r.bril ? null : dealprijs != null ? Math.max(r.c, r.p) : (r.c > r.p ? r.c : null);
    const bespaarEuro = door ? door - nu : 0;
    const bespaarPct = door ? Math.floor(bespaarEuro * 100 / door) : 0;
    return {nu, door, bespaarEuro, bespaarPct, deal: dealprijs != null, bespaarIn: dealprijs != null && !inPct ? 'euro' : (door ? 'pct' : null)};
  }
  // Labels (BESLUITEN 14b, Geert 10-10: elk bedrag in de koopbox is een besparing, nooit een plus): wat Shopify voor de
  // huidige keuze echt toekent. zelf: de rij krijgt zelf korting ("2e artikel −20%", dealprijs). ander (14b.2): de
  // korting die de aangevinkte rijen erbij brengen op een stuk dat geen rij is, tegenover de basis (winkelwagen plus het
  // hoofdproduct maal het aantal), met alleen de winst op dat ene stuk ("Je powerbank −€7,99", WP deallabel), op één
  // aangevinkte rij zonder eigen korting: de rij die het al toonde (drager), anders de rij die net aanging (nieuw), anders
  // de eerste. Korting die het hoofdproduct al zonder aanvullers krijgt (van de winkelwagen of van zijn eigen aantal) staat
  // alleen in het totaal, op geen rij. Met hooguit twee rijen krijgt hooguit één stuk er korting bij, en dan heeft geen rij
  // eigen korting.
  // Een rij die niet aan staat (WP deallabel, Geert 11-10: "dat hij bij onderste beide laat zien klopt niet toch?"): gewoon
  // zijn eigen prijs, zonder label. Alleen als aanvinken de korting op precies deze rij laat landen (of op een stuk dat geen
  // rij is) zonder dat een ander stuk korting verliest en zonder dat het label van een aangevinkte rij verandert, toont hij
  // het label en de prijs die hij dan krijgt (een voorspelling die na aanvinken klopt, en het totaal groeit met precies die
  // prijs). Hooguit één rij voorspelt: de laagste meerprijs, dan de grootste besparing, dan de volgorde. Zo staat de korting
  // nooit op twee rijen als Shopify hem aan één stuk geeft (gemeten op banky.nl, 11-10, scratchpad deal/allocatie.json).
  const zelfdeLabel = (a, b) => (!a && !b) || (!!a && !!b && a.soort === b.soort && a.bedrag === b.bedrag && (a.landtOp ?? null) === (b.landtOp ?? null));
  // paar (20-10-2026): het voordeel per paar brillen; totaal en korting tellen de duoprijs mee, de labels alleen de x%.
  // groepen (20-10-2026): met de kortingen "2e stuk zelfde prijs" (deal, prijsgroepen; thema-instelling banky_deal_groepen).
  function koopbox({wagen = [], hoofd, aantal = 1, rijen, pct = 20, actief = true, drager = null, nieuw = null, paar = 0, groepen = true}) {
    const P = actief ? pct : 0;
    let v = wagen.reduce((m, s) => Math.max(m, s.volg), -1) + 1;
    const hoofdStukken = Array.from({length: aantal}, (_, i) => ({...hoofd, id: 'h', volg: v + i})); v += aantal;
    const rijStuk = rijen.map((r, i) => ({...r, volg: v + i}));
    const telt = r => r.aan && !r.kiesEerst;
    const basis = [...wagen, ...hoofdStukken];
    const gekozen = rijStuk.filter(telt);
    const S = [...basis, ...gekozen];
    const dW = deal(wagen, P, paar, groepen), dB = deal(basis, P, paar, groepen), dS = deal(S, P, paar, groepen);
    // Prijsgroepen (20-10-2026): wint met de rijen een groep, dan vervalt de duoprijs van de basis; dat telt af van de extra
    // korting (zonder groepen verliest de basis nooit duoprijs, dan is dit 0). Andersom (toets 21-10): verliest de basis zijn
    // groep en komt de duoprijs terug zonder aangevinkte bril, dan telt die mee (zoals in nettoLabels; zonder groepen 0).
    const extraKorting = dS.tot - dB.tot - Math.max(0, dB.duo - dS.duo) + (groepen && !gekozen.some(g => g.bril) ? Math.max(0, dS.duo - dB.duo) : 0);
    const korting = (dS.tot + dS.duo) - (dW.tot + dW.duo);
    const totaal = som([...hoofdStukken, ...gekozen], x => x.p) - korting;
    const van = som([...hoofdStukken, ...gekozen], x => x.c);
    const lab = nettoLabels(labelsAan(gekozen, dB, dS, P, drager, nieuw), gekozen, dB, dS, P, groepen);
    const dragerNu = ([...lab].find(([, l]) => l.soort === 'ander') || [null])[0];
    const knop = gekozen.length === 0 ? 'leeg' : [...lab.values()].some(l => l.soort !== 'schuif') ? 'deal' : 'gewoon';
    let voorspeld = null;
    // Geen voorspelling als een aangevinkte rij een label netto of schuif heeft (de basis verliest korting; met de prijsgroepen
    // vaker, 20-10-2026): zo blijft de eerste stand uit snippets/banky-complete-addons.liquid gelijk aan deze.
    const basisVerliest = [...lab.values()].some(l => l.soort !== 'zelf' && l.soort !== 'ander');
    if (P > 0 && !basisVerliest) rijStuk.forEach(r => {
      if (telt(r) || r.kiesEerst) return;
      const dM = deal([...S, r], P, paar, groepen);
      for (const [k, kk] of dS.op) if ((dM.op.get(k) || 0) < kk) return;
      // ook geen duoprijs kwijt (prijsgroepen: een groep die wint laat de duoprijs vervallen)
      if (dM.duo < dS.duo) return;
      const metR = [...gekozen, r].sort((a, b) => a.volg - b.volg);
      const labM = nettoLabels(labelsAan(metR, dB, dM, P, dragerNu, r.id), metR, dB, dM, P, groepen);
      if (gekozen.some(g => !zelfdeLabel(lab.get(g.id), labM.get(g.id)))) return;
      const l = labM.get(r.id);
      // alleen zelf of ander, zoals snippets/banky-deal-voorspel.liquid (netto kan sinds 21-10 met de prijsgroepen ook uit winst
      // ontstaan; dat voorspelt de Liquid niet, dus hier ook niet)
      if (!l || l.soort === 'schuif' || l.soort === 'netto') return;
      // Prijsgroepen (20-10-2026): een stuk dat al korting kreeg door de aangevinkte rijen (een rij met eigen korting die ook
      // een ander stuk zijn 20% teruggeeft) wint niets met deze rij; dan geen voorspelling "Je kabel −€x" op deze rij.
      if (l.soort === 'ander' && !((dM.op.get(l.landtOp) || 0) > (dS.op.get(l.landtOp) || 0))) return;
      const meer = r.p - ((dM.tot + dM.duo) - (dS.tot + dS.duo)), bes = r.c - meer;
      if (!voorspeld || meer < voorspeld.meer || (meer === voorspeld.meer && bes > voorspeld.bes)) voorspeld = {id: r.id, l, meer, bes};
    });
    // Duoprijs op de rij (toets 20-10, K02): een aangevinkte bril die met een bril in de winkelwagen (of het hoofdproduct) een
    // paar maakt, kost wat Shopify ervoor rekent (39,95 min de duoprijs per paar: €20,00) met het label "Duoprijs: samen
    // €59,95", zonder doorhaling. Zo tellen de rijen op tot het totaal, zoals de brilkaart in de lade. Alleen als de rij geen
    // label van de 20% heeft; het label telt niet als deal voor de knop.
    const duoErbij = Math.min(Math.max(0, dS.duo - dB.duo), paar);
    const rijenUit = rijStuk.map(r => {
      let l = null;
      if (P > 0 && !r.kiesEerst) l = telt(r) ? lab.get(r.id) || null : voorspeld && voorspeld.id === r.id ? voorspeld.l : null;
      if (!l && telt(r) && r.bril && duoErbij > 0 && duoErbij < r.p) l = {soort: 'duo', bedrag: duoErbij};
      const soort = l ? l.soort : null;
      return {id: r.id, aan: telt(r), soort, landtOp: l && l.landtOp != null ? l.landtOp : null, bedrag: l ? l.bedrag : 0, samen: soort === 'duo' ? 2 * r.p - l.bedrag : 0, ...prijsregel(r, soort === 'zelf' || soort === 'netto' || soort === 'duo' ? r.p - l.bedrag : null, true)};
    });
    return {totaal, van, bespaar: van - totaal, extraKorting, korting, knop, drager: dragerNu, voorspeld: voorspeld ? voorspeld.id : null, rijen: rijenUit, gekozen: gekozen.map(g => g.id)};
  }
  function labelsAan(gekozen, dB, dS, P, drager = null, nieuw = null) {
    const lab = new Map();
    if (!(P > 0) || !gekozen.length) return lab;
    const ids = new Set(gekozen.map(g => g.id));
    gekozen.forEach(r => { const o = dS.op.get(r.id) || 0; if (o > 0) lab.set(r.id, {soort: 'zelf', bedrag: o}); });
    let landtOp = null, max = 0;
    for (const [k, kk] of dS.op) { const d = kk - (dB.op.get(k) || 0); if (!ids.has(k) && d > max) { max = d; landtOp = k; } }
    if (landtOp != null) {
      const vrij = gekozen.filter(g => !lab.has(g.id));
      const r = vrij.find(g => g.id === drager) || vrij.find(g => g.id === nieuw) || vrij[0];
      if (r) lab.set(r.id, {soort: 'ander', landtOp, bedrag: max});
    }
    return lab;
  }
  // Duo knop (19-10-2026, /Users/geert/banky-r1-werk/duo-knop/BOUWPLAN.md §3.9): netto labels. De basis (winkelwagen plus het hoofdproduct maal
  // het aantal, bij "2 stuks" dus ook de duo) houdt in beeld zijn eigen korting. Shopify geeft de korting per 2 stuks aan de
  // goedkoopste stukken (gemeten 19-10: 2 powerbanks 50.000 en een kabel 65W geven alleen de kabel −€2,59, de powerbanks
  // niets). Neemt een aangevinkte rij zo korting van de basis over, dan toont de rij alleen wat hij er netto bij brengt: het
  // verlies van de basis gaat eerst af van de duurste rij met eigen korting. Een rij met een deel van zijn korting over krijgt
  // het label "netto" (Extra korting −€x, met die dealprijs). Blijft er verlies over, dan het label "schuif" (Je 20% gaat naar
  // deze kabel: +€6,40, de tekst van de lade) op de goedkoopste rij die de korting overnam, met zijn gewone prijs. Zo tellen
  // duotegel, rijen en totaal altijd op tot wat Shopify rekent. Zonder verlies verandert er niets.
  // Prijsgroepen (toets 21-10, P7b en P12): verliest de basis zijn groep omdat NAJAARSDEALS met de rijen weer wint, dan krijgt
  // vaak ook een ander stuk in de basis zijn 20% terug of komt de duoprijs terug. Die winst staat op geen label (geen vrije rij
  // voor "Je kabel −€x", geen aangevinkte bril voor de duoprijs) en telt daarom tegen het verlies: kabel 240W in de wagen, 2
  // powerbanks 50.000 en de reisadapter geeft de reisadapter "Bespaar €3,59" (netto: de kabel krijgt zijn 3,59 terug), niet
  // geen label. Is de winst groter dan het verlies, dan krijgt de duurste rij met eigen korting (anders de rij met "Je kabel
  // −€x") de rest erbij (netto). Blijft er na de rijen met eigen korting verlies over, dan gaat dat ook af van het label "Je
  // kabel −€x" (netto, of geen label): een rij die een groep laat winnen kan een stuk korting geven terwijl een ander stuk
  // meer verliest, en dan is er geen deal. Zonder prijsgroepen is die winst er niet en verliest de basis niets naast een
  // label "Je kabel −€x" (dan alleen de regels hierboven). Alleen met groepen (thema-instelling banky_deal_groepen): zonder
  // groepen precies zoals vóór 21-10.
  function nettoLabels(lab, gekozen, dB, dS, P, groepen = false) {
    if (!(P > 0) || !gekozen.length) return lab;
    let verlies = 0;
    for (const [k, kk] of dB.op) verlies += Math.max(0, kk - (dS.op.get(k) || 0));
    // Prijsgroepen (20-10-2026): wint met de rijen een groep, dan verliest de basis ook zijn duoprijs (zonder groepen nooit).
    verlies += Math.max(0, (dB.duo || 0) - (dS.duo || 0));
    const ids = new Set(gekozen.map(g => g.id));
    let winst = 0;
    if (groepen) {
      for (const [k, kk] of dS.op) if (!ids.has(k)) winst += Math.max(0, kk - (dB.op.get(k) || 0));
      for (const l of lab.values()) if (l.soort === 'ander') winst -= l.bedrag;
      if (!gekozen.some(g => g.bril)) winst += Math.max(0, (dS.duo || 0) - (dB.duo || 0));
      winst = Math.max(0, winst);
    }
    const zelf = gekozen.filter(g => lab.get(g.id) && lab.get(g.id).soort === 'zelf');
    const ander = groepen ? gekozen.find(g => lab.get(g.id) && lab.get(g.id).soort === 'ander') || null : null;
    if (winst > verlies) {
      const g = [...zelf].sort((a, b) => b.p - a.p || a.volg - b.volg)[0] || ander;
      if (g) lab.set(g.id, {soort: 'netto', bedrag: lab.get(g.id).bedrag + winst - verlies});
      return lab;
    }
    verlies -= winst;
    if (!verlies) return lab;
    const goedkoopste = [...zelf].sort((a, b) => a.p - b.p || b.volg - a.volg)[0] || null;
    zelf.sort((a, b) => b.p - a.p || a.volg - b.volg);
    for (const g of zelf) {
      if (!verlies) break;
      const l = lab.get(g.id), af = Math.min(verlies, l.bedrag);
      verlies -= af;
      if (l.bedrag - af > 0) lab.set(g.id, {soort: 'netto', bedrag: l.bedrag - af});
      else lab.delete(g.id);
    }
    if (verlies > 0 && ander) {
      const l = lab.get(ander.id), af = Math.min(verlies, l.bedrag);
      verlies -= af;
      if (l.bedrag - af > 0) lab.set(ander.id, {soort: 'netto', bedrag: l.bedrag - af});
      else lab.delete(ander.id);
    }
    if (verlies > 0 && goedkoopste && !lab.has(goedkoopste.id)) lab.set(goedkoopste.id, {soort: 'schuif', bedrag: verlies});
    return lab;
  }
  // Vooraf aanvinken (Geert 06-10: "Ik wil sws iets aangefinkt in de upsell sectie wat het sterkst doet overzetten tot koop en
  // korting effect."): alleen rijen zonder keuze vooraf die niet al in de winkelwagen liggen; voorkeur korting, dan de laagste
  // meerprijs, dan de grootste besparing, dan de volgorde. Een rij die korting laat schuiven telt als geen korting: de
  // meerprijs bevat de korting die verloren gaat al.
  function kiesVooraf({wagen = [], hoofd, aantal = 1, rijen, pct = 20, actief = true, vooraf = true, paar = 0, groepen = true}) {
    if (!actief || !vooraf) return null;
    let best = null;
    rijen.forEach((r, i) => {
      if (r.kiesEerst || r.inWagen) return;
      const res = koopbox({wagen, hoofd, aantal, rijen: rijen.map(x => ({...x, aan: x.id === r.id})), pct, actief, paar, groepen});
      const s = {id: r.id, deal: res.extraKorting > 0 ? 1 : 0, meer: res.totaal, bes: res.bespaar, i};
      if (!best || s.deal > best.deal || (s.deal === best.deal && (s.meer < best.meer || (s.meer === best.meer && s.bes > best.bes)))) best = s;
    });
    return best ? best.id : null;
  }
  // Instelling uit snippets/banky-deal-instelling.liquid ("aan|pct|titel|vooraf|einde|einde_fout|groepen|groep_titel"; de
  // Liquid zet een einddatum als DD-MM-JJJJ al om naar JJJJ-MM-DD) en de einddatum nog een keer in de browser (Amsterdamse
  // tijd), tegen een pagina die Shopify kort in de cache hield. groepen: de prijsgroepen (zonder veld: aan, zoals de Liquid).
  // groepTitel: het begin van de titel van de kortingen "2e stuk zelfde prijs €x" (telt mee als korting van de actie).
  const vandaag = () => { try { return new Intl.DateTimeFormat('sv-SE', {timeZone: 'Europe/Amsterdam'}).format(new Date()); } catch { return new Date().toISOString().slice(0, 10); } };
  const naEinde = einde => /^\d{4}-\d{2}-\d{2}$/.test(einde || '') && vandaag() > einde;
  function leesInstelling(tekst) {
    const [aan, pct, titel, vooraf, einde, , groepen, groepTitel] = String(tekst || '').split('|');
    const actief = aan === 'true' && !naEinde(einde);
    return {aan: actief, pct: Number(pct) || 0, titel: titel || '', vooraf: actief && vooraf === 'true', einde: einde || '', groepen: groepen !== 'false', groepTitel: groepen !== 'false' ? groepTitel || '' : ''};
  }
  // Korte naam uit product.type, zoals snippets/banky-deal-kort.liquid.
  function kortVanType(type) {
    const t = String(type || '').trim();
    if (!t || t.split(' > ')[0] === 'Bundels') return 'bundel';
    if (t.includes('Reisadapters')) return 'reisadapter';
    if (t.includes('Autohouders')) return 'autohouder';
    if (t.includes('hoesjes')) return 'hoesje';
    return {Powerbanks: 'powerbank', Kabels: 'kabel', Opladers: 'oplader', Houders: 'houder', Brillen: 'bril'}[t.split(' > ')[0]] || 'artikel';
  }
  // Kan dit product de korting zelf krijgen? Zoals snippets/banky-deal-geldt.liquid: nee als het producttype begint met
  // "Bundels" (elke bundel); een bundel telt wel mee als eerste artikel. Een bril (type "Brillen") wel, sinds 20-10-2026
  // (Geert: "bril + product of product + bril is wel 2e 20%"); brilVanType zegt of het een bril is (de duoprijs).
  function krijgtVanType(type) {
    const begin = String(type || '').trim().split(' > ')[0].trim();
    return begin !== 'Bundels';
  }
  function brilVanType(type) {
    return String(type || '').trim().split(' > ')[0].trim() === 'Brillen';
  }
  // Winkelwagen als stukken: items nieuwste eerst (Liquid cart.items en /cart.js), elk stuk apart. binnen: wat Shopify zelf
  // aan de korting met deze titel op de regels zet (line_level_discount_allocations; in het JSON-blok van de Liquid k), plus
  // de kortingen waarvan de titel met groepTitel begint ("2e stuk zelfde prijs €x", prijsgroepen 20-10-2026).
  // g: kan de korting krijgen (in het JSON-blok van de Liquid 1 of 0, uit /cart.js via product_type). bril: een bril (in het
  // JSON-blok b 1 of 0, uit /cart.js via product_type). gr: de prijsgroepen van het product (in het JSON-blok van de Liquid
  // gr, snippets/banky-deal-groep.liquid; uit /cart.js via groepKaart per handle, de producten met meer prijzen; anders de
  // eigen prijs).
  const telt = (a, titel, groepTitel) => !!(a && a.discount_application) && ((!!titel && a.discount_application.title === titel) || (!!groepTitel && String(a.discount_application.title || '').startsWith(groepTitel)));
  function stukkenUit(items, kortTekst = {}, titel = '', groepTitel = '', groepKaart = {}) {
    const lijst = (items || []).map(x => ({
      p: Number(x.original_price ?? x.p) || 0,
      n: Number(x.quantity ?? x.n) || 0,
      h: x.handle ?? x.h ?? '',
      g: x.g != null ? Number(x.g) !== 0 : krijgtVanType(x.product_type),
      bril: x.b != null ? Number(x.b) === 1 : brilVanType(x.product_type),
      kort: x.kort ?? kortTekst[kortVanType(x.product_type)] ?? kortVanType(x.product_type),
      k: x.k != null ? Number(x.k) || 0 : (x.line_level_discount_allocations || []).reduce((t, a) => t + (telt(a, titel, groepTitel) ? Number(a.amount) || 0 : 0), 0),
      gr: x.gr ?? (groepKaart || {})[x.handle ?? x.h ?? ''],
      v: x.variant_id ?? x.v ?? '',
      // Duo (Geert 21-10-2026): d de variant heeft een geldige verborgen bundel van 2 stuks (in het JSON-blok d 1, uit
      // snippets/banky-duo-paar.liquid; uit /cart.js onbekend: deal paart dan via een ander stuk met d). Een regel van zo'n
      // bundel (type "Bundels > Duo", in het JSON-blok x 1) doet niet mee aan de actie: geen stukken, de plek blijft.
      d: x.d != null && Number(x.d) === 1,
      weg: Number(x.x) === 1 || String(x.product_type || '').trim() === 'Bundels > Duo',
    }));
    // De handle van zo'n bundel is "2x-" plus die van het losse product (/Users/geert/banky-r1-werk/duo-bundels/log.md): het
    // losse product telt dan als in de winkelwagen (rijen van Maak het compleet), zoals in de Liquid.
    lijst.forEach(x => { if (x.weg) x.h = String(x.h || '').replace(/^2x-/, ''); });
    // volg: 1000 per regel, zoals snippets/banky-deal-stand.liquid (uniek tot 999 stuks per regel; toets 20-10 avond).
    const stukken = [];
    // v: het variant-id (/cart.js variant_id, in het JSON-blok v), voor het aantal per variant in deal (een regel die Shopify
    // splitst blijft één variant).
    lijst.forEach((x, i) => { if (x.weg) return; for (let q = 0; q < x.n; q++) stukken.push({id: 'w' + i, p: x.p, c: x.p, volg: (lijst.length - 1 - i) * 1000 + q, kort: x.kort, g: x.g, bril: x.bril, gr: x.gr, v: x.v, d: x.d}); });
    return {stukken, regels: lijst, binnen: som(lijst, x => x.k)};
  }
  // Rekent Shopify zoals de regel? Te zien vanaf 2 stuks in de winkelwagen: dan moet de eigen som gelijk zijn aan wat Shopify
  // op de regels zet (toetsronde 06-10, M2; zoals de lade in banky-deal-stand). Wijkt het af (ander percentage, korting in
  // Shopify gestopt of veranderd), dan rekent de koopbox zonder de actie.
  const dealKlopt = (stukken, binnen, pct, paar = 0, groepen = true) => stukken.length < 2 || deal(stukken, pct, paar, groepen).tot === binnen;
  // Meting zonder persoonsgegevens (window.dataLayer, eventnaam banky_..., zoals banky_voorraadmelding): alleen id's,
  // bedragen in centen, plek en vlaggen.
  const meet = (event, velden) => { try { (window.dataLayer = window.dataLayer || []).push({event, ...velden}); } catch {} };
  window.bankyDeal = {deal, groepVan, koopbox, labelsAan, nettoLabels, prijsregel, kiesVooraf, kortVanType, krijgtVanType, brilVanType, stukkenUit, dealKlopt, leesInstelling, naEinde, meet, versie: 7};

  /* ---- Maak het compleet ------------------------------------------------------------------------------------- */
  // Een extra telt alleen met een echt variant-id. Een vinkje zonder value-attribuut heeft in de browser de waarde "on";
  // het hoesje (keuzelijst zonder voorkeuze) heeft value="" tot er een iPhone-model gekozen is (slot 02-10, punt 1).
  const gekozenVariant = vink => /^\d+$/.test(vink.value || '');
  const zetTekst = (el, tekst) => { if (el && el.textContent !== tekst) el.textContent = tekst; };
  const zetVerborgen = (el, verborgen) => { if (el && el.hidden !== verborgen) el.hidden = verborgen; };
  class BankyComplete extends HTMLElement {
    connectedCallback() {
      if (this._klaar) return;
      this._klaar = true;
      try { this.tekst = JSON.parse(this.querySelector('[data-banky-compleet-tekst]')?.textContent || '{}'); } catch { this.tekst = {}; }
      this.instelling = leesInstelling(this.tekst.deal);
      // Voordeel per paar brillen (snippets/banky-bril-paar.liquid; 0 zonder duoprijs), vóór zetWagen (dealKlopt rekent ermee).
      this.paar = Number(this.tekst.duoPaar) || 0;
      this.zetWagen(this.tekst.wagen || []);
      this.knop = this.querySelector('[data-banky-compleet-knop]');
      this.melding = this.querySelector('[data-banky-compleet-melding]');
      this.addEventListener('change', e => this.wijziging(e));
      this.knop?.addEventListener('click', () => this.voegToe());
      const aantal = this.aantalVeld();
      aantal?.addEventListener('input', () => this.reken());
      aantal?.addEventListener('change', () => this.reken());
      // Halo's aantalknoppen zetten de waarde zonder input-gebeurtenis op het veld zelf; de klik bubbelt wel.
      aantal?.closest('quantity-selector')?.addEventListener('click', () => requestAnimationFrame(() => this.reken()));
      // Vooraf aanvinken: alleen hier, bij het openen van de pagina. De Liquid zette hetzelfde vinkje al (geen verspringen);
      // na deze regel zet de site nooit meer zelf een vinkje (BESLUITEN, juridische maatregel 4).
      const rijen = this.rijen();
      const id = this.instelling.vooraf && this.wagenOk ? kiesVooraf({wagen: this.wagen, hoofd: this.hoofd(), aantal: this.aantal(), rijen, pct: this.instelling.pct, actief: this.actief(), paar: this.paar, groepen: this.instelling.groepen}) : null;
      this.voorafVink = null;
      this.extra().forEach((vink, i) => {
        const moet = id === 'e' + (i + 1);
        if (vink.checked !== moet) vink.checked = moet;
        vink.toggleAttribute('data-banky-vooraf', moet);
        if (moet) this.voorafVink = vink;
      });
      this.reken();
      // De winkelwagen rekent mee: na elke wijziging levert Halo de nieuwe wagen (cart:change); bij cart:refresh en na
      // terugkeren uit de bfcache zelf ophalen. Nooit opnieuw vooraf aanvinken.
      document.addEventListener('cart:change', e => { const c = e.detail && e.detail.cart; if (c && Array.isArray(c.items)) { this.zetWagen(c.items); this.reken(); } });
      const haal = () => fetch(wortel() + 'cart.js').then(r => r.json()).then(c => { if (Array.isArray(c.items)) { this.zetWagen(c.items); this.reken(); } }).catch(() => {});
      document.addEventListener('cart:refresh', haal);
      window.addEventListener('pageshow', e => { if (e.persisted) haal(); });
      this.meetWeergave();
    }
    zetWagen(items) {
      // groepen: de prijzen van de producten met meer prijzen (snippets/banky-deal-groep.liquid, kaart), voor /cart.js.
      const {stukken, regels, binnen} = stukkenUit(items, this.tekst.kort || {}, this.instelling.titel, this.instelling.groepTitel, this.tekst.groepen || {});
      this.wagen = stukken;
      this.wagenRegels = regels;
      this.wagenHandles = new Set(regels.map(r => r.h));
      this.wagenOk = dealKlopt(stukken, binnen, this.instelling.pct, this.paar || 0, this.instelling.groepen);
    }
    actief() { return this.instelling.aan && this.wagenOk; }
    // Toetsronde 06-10 (beeld 2): niet herrekenen terwijl de winkelwagenlade open is (labels en prijsregels onder de lade
    // schoven, CLS na "Pak je deal"); zodra de lade dichtgaat (attribuut open weg, binnen de klik) alsnog.
    wachtOpLade() {
      const lade = document.querySelector('cart-drawer');
      if (!lade || !lade.hasAttribute('open')) return false;
      if (!this._ladeWacht) {
        this._ladeWacht = new MutationObserver(() => {
          if (lade.hasAttribute('open')) return;
          this._ladeWacht.disconnect();
          this._ladeWacht = null;
          this.reken();
        });
        this._ladeWacht.observe(lade, {attributes: true, attributeFilter: ['open']});
      }
      return true;
    }
    // data-krijgt="false" (snippets/banky-deal-geldt.liquid): een bundel als hoofdproduct krijgt nooit zelf de korting.
    // data-bril: het hoofdproduct is een bril (de duoprijs bij 2 stuks, nooit doorgestreept).
    // data-gr: de prijsgroepen van het product (snippets/banky-deal-groep.liquid; zonder: de eigen prijs).
    // v: het variant-id (data-hoofd, of value van het vinkje), voor het aantal per variant in deal (21-10).
    // d: de variant heeft een geldige verborgen bundel van 2 stuks (data-duo, snippets/banky-duo-paar.liquid; Geert 21-10).
    hoofd() { return {p: Number(this.dataset.prijs || 0), c: Number(this.dataset.van || this.dataset.prijs || 0), kort: this.dataset.kort || '', g: this.dataset.krijgt !== 'false', bril: this.hasAttribute('data-bril'), gr: this.dataset.gr, v: this.dataset.hoofd || '', d: this.hasAttribute('data-duo')}; }
    rijen() {
      return this.extra().map((v, i) => ({
        id: 'e' + (i + 1), p: Number(v.dataset.prijs || 0), c: Number(v.dataset.van || v.dataset.prijs || 0),
        aan: v.checked && gekozenVariant(v), kiesEerst: !gekozenVariant(v), inWagen: this.wagenHandles.has(v.dataset.handle), kort: v.dataset.kort || '',
        g: v.dataset.krijgt !== 'false', bril: v.hasAttribute('data-bril'), gr: v.dataset.gr, v: gekozenVariant(v) ? v.value : '', d: v.hasAttribute('data-duo'),
      }));
    }
    kortVan(id) {
      if (id === 'h') return this.dataset.kort || '';
      if (/^w\d+$/.test(id)) return (this.wagenRegels[Number(id.slice(1))] || {}).kort || '';
      const vink = this.extra()[Number(String(id).slice(1)) - 1];
      return vink ? vink.dataset.kort || '' : '';
    }
    aantalVeld() { return document.querySelector(`input[name="quantity"][form="${CSS.escape(this.dataset.form || '')}"]`); }
    aantal() { const n = parseInt(this.aantalVeld()?.value, 10); return Number.isFinite(n) && n > 0 ? n : 1; }
    extra() { return [...this.querySelectorAll('[data-banky-extra]')]; }
    rijId(vink) { return 'e' + (this.extra().indexOf(vink) + 1); }
    toonMelding(tekst) {
      if (!this.melding) return;
      this.melding.textContent = tekst || '';
      this.melding.hidden = !tekst;
    }
    zetHoofd(variant) {
      if (!variant) return;
      this.dataset.hoofd = variant.id;
      this.dataset.prijs = variant.price;
      // Van-prijs (BESLUITEN §18, Geert 31-10-2026: "altijd vanaf de van-prijs hoogste korting laten zien"): bij een bundel
      // (data-bundel) de som van de gewone prijzen van de onderdelen per variant (data-bundel-van uit banky-complete-addons,
      // "id:van,"), nooit zijn eigen compare_at; de Duo Bundel van de brillen geeft zijn van-prijs mee als bundelVan
      // (assets/banky-bril.js). Anders compare_at_price als die hoger is.
      if (this.hasAttribute('data-bundel')) {
        const m = new RegExp(',' + variant.id + ':(\\d+),').exec(this.dataset.bundelVan || '');
        const bv = m ? Number(m[1]) : Number(variant.bundelVan) || 0;
        this.dataset.van = bv > variant.price ? bv : variant.price;
      } else this.dataset.van = variant.compare_at_price > variant.price ? variant.compare_at_price : variant.price;
      // Duo-bundels (review 21-10): de geldigheid hoort per variant (data-duo-varianten uit banky-complete-addons).
      if (this.dataset.duoVarianten != null) this.toggleAttribute('data-duo', this.dataset.duoVarianten.includes(',' + variant.id + ','));
      // Black Friday-bundel (ronde 6): de foto van de vaste regel volgt de gekozen variant (kleur), zoals de galerij.
      const foto = this.querySelector('[data-bfb-hoofd-foto] img');
      const bron = variant.featured_media?.preview_image?.src || variant.featured_image?.src || '';
      if (foto && bron) {
        const maat = w => { try { const u = new URL(bron.startsWith('//') ? 'https:' + bron : bron, location.href); u.searchParams.set('width', w); return u.href; } catch { return bron; } };
        const set = `${maat(56)} 56w, ${maat(112)} 112w`;
        if (foto.getAttribute('srcset') !== set) { foto.setAttribute('srcset', set); foto.setAttribute('src', maat(112)); }
      }
      this.hidden = !variant.available;
      this.reken();
    }
    wijziging(e) {
      const voor = this.stand;
      const keuze = e.target.closest('[data-banky-extra-keuze]');
      if (keuze) {
        const item = keuze.closest('.banky-compleet__item'), vink = item?.querySelector('[data-banky-extra]'), optie = keuze.selectedOptions[0];
        if (vink && optie && optie.value) {
          vink.value = optie.value;
          vink.dataset.prijs = optie.dataset.prijs;
          vink.dataset.van = optie.dataset.van;
          vink.toggleAttribute('data-duo', optie.hasAttribute('data-duo'));
          // Een iPhone-model kiezen is de keuze van de klant voor die rij: het hoesje gaat dan aan (zoals sinds 02-10).
          if (vink.dataset.kiesEerst && !vink.checked) { vink.checked = true; this.meetAanvink(vink, voor); this.nieuw = this.rijId(vink); }
          this.toonMelding('');
        }
      }
      const vink = e.target.closest('[data-banky-extra]');
      if ((vink && vink === this.voorafVink) || (keuze && this.voorafVink && keuze.closest('.banky-compleet__item') === this.voorafVink.closest('.banky-compleet__item'))) this._voorafAangeraakt = true;
      if (vink && vink.checked && !gekozenVariant(vink) && vink.dataset.kiesEerst) {
        vink.checked = false;
        this.toonMelding(vink.dataset.kiesEerst);
        vink.closest('.banky-compleet__item')?.querySelector('[data-banky-extra-keuze]')?.focus();
      } else if (vink && e.target === vink) {
        // De rij die net aanging draagt het label "goedkoper" als er nog geen drager is: zo toont hij na het aanvinken
        // wat hij ervoor voorspelde (14b.2).
        if (vink.checked) { this.meetAanvink(vink, voor); this.nieuw = this.rijId(vink); }
        else if (vink === this.voorafVink && !this._uitgevinkt) {
          this._uitgevinkt = true;
          meet('banky_upsell_uitvink', {banky_plek: 'koopbox', banky_product: this.dataset.product || '', banky_variant: vink.value || ''});
        }
      }
      this.reken();
    }
    // Duo knop (19-10-2026, duo-knop/BOUWPLAN.md §3.9): kiest de klant 2 stuks of meer en levert het vooraf aangevinkte extra dan
    // geen korting meer op (de 20% zou alleen van de 2e powerbank naar dat extra schuiven), dan haalt de site haar eigen vinkje
    // weg: één keer, en alleen als de klant het niet zelf heeft aangeraakt. De site zet nooit zelf een vinkje terug (BESLUITEN,
    // juridische maatregel: na het openen van de pagina zet de site nooit meer zelf een vinkje), ook niet bij terug naar 1 stuk.
    voorafWeg(pct) {
      const v = this.voorafVink;
      if (!v || !v.checked || this._voorafAangeraakt || this._voorafWeg || this.aantal() < 2) return;
      const proef = koopbox({wagen: this.wagen, hoofd: this.hoofd(), aantal: this.aantal(), rijen: this.rijen(), pct, actief: this.actief(), paar: this.paar, groepen: this.instelling.groepen});
      if (proef.extraKorting > 0) return;
      v.checked = false;
      v.removeAttribute('data-banky-vooraf');
      this._voorafWeg = true;
      meet('banky_upsell_vooraf_weg', {banky_plek: 'koopbox', banky_product: this.dataset.product || '', banky_variant: v.value || '', banky_aantal: this.aantal()});
    }
    meetAanvink(vink, voor) {
      const i = this.extra().indexOf(vink);
      const soort = (voor && voor.rijen[i] && voor.rijen[i].soort) || 'geen';
      meet('banky_upsell_aanvink', {banky_plek: 'koopbox', banky_product: this.dataset.product || '', banky_variant: vink.value || '', banky_soort: soort});
    }
    reken() {
      if (this.wachtOpLade()) return;
      const t = this.tekst, pct = this.instelling.pct;
      this.voorafWeg(pct);
      const r = koopbox({wagen: this.wagen, hoofd: this.hoofd(), aantal: this.aantal(), rijen: this.rijen(), pct, actief: this.actief(), drager: this.drager || null, nieuw: this.nieuw || null, paar: this.paar, groepen: this.instelling.groepen});
      this.stand = r;
      this.drager = r.drager;
      const vinken = this.extra();
      vinken.forEach((vink, i) => {
        const uit = r.rijen[i], item = vink.closest('.banky-compleet__item');
        if (!item || !uit) return;
        let tekst = '';
        if (uit.soort === 'zelf') tekst = (t.labelZelf || '').replace('{pct}', pct);
        else if (uit.soort === 'ander') tekst = (t.labelAnder || '').replace('{pct}', pct).replace('{kort}', this.kortVan(uit.landtOp)).replace('{bedrag}', geld(uit.bedrag, t.geld));
        else if (uit.soort === 'schuif') tekst = (t.labelSchuif || 'Je {pct}% gaat naar deze {kort}: +\u2060{bedrag}').replace('{pct}', pct).replace('{kort}', this.kortVan(uit.id)).replace('{bedrag}', geld(uit.bedrag, t.geld));
        else if (uit.soort === 'netto') tekst = (t.labelNetto || 'Extra korting \u2212\u2060{bedrag}').replace('{bedrag}', geld(uit.bedrag, t.geld));
        else if (uit.soort === 'duo') tekst = (t.labelDuo || '').replace('{prijs}', geld(uit.samen, t.geld));
        const label = item.querySelector('[data-banky-compleet-label]');
        if (label && label.dataset.soort !== (uit.soort || '')) label.dataset.soort = uit.soort || '';
        // Ronde 6: hetzelfde soort op de rij zelf (het telefoonblok zet het label schuif op een eigen regel, zonder :has()).
        if (item.dataset.soort !== (uit.soort || '')) item.dataset.soort = uit.soort || '';
        zetTekst(label?.querySelector('[data-banky-compleet-label-tekst]'), tekst);
        zetVerborgen(label, !tekst);
        const regel = item.querySelector('[data-banky-prijsregel]');
        this.zetPrijsregel(regel, uit);
        const beschrijving = [tekst && label ? label.id : '', regel ? regel.id : ''].filter(Boolean).join(' ');
        if (vink.getAttribute('aria-describedby') !== beschrijving) vink.setAttribute('aria-describedby', beschrijving);
      });
      zetTekst(this.querySelector('[data-banky-totaal]'), geld(r.totaal, t.geld));
      const besparing = this.querySelector('[data-banky-besparing]');
      zetTekst(besparing, r.bespaar > 0 ? (t.bespaar || '').replace('{savings}', geld(r.bespaar, t.geld)) : '');
      zetVerborgen(besparing, !(r.bespaar > 0));
      // Black Friday-bundel (ronde 6, BESLUITEN §45): alleen tekst, dezelfde stand r (geen eigen rekenwerk). Na het einde
      // (html.bf-voorbij: pagina uit de cache of open over het einde heen) de gewone teksten.
      const voorbij = document.documentElement.classList.contains('bf-voorbij');
      const bundel = t.bundel && this.classList.contains('bfb') && !voorbij ? t.bundel : null;
      if (t.bundel && this.classList.contains('bfb')) this.tekenBundel(r, t.bundel, voorbij);
      if (this.knop) {
        const gekozen = vinken.filter(v => v.checked && gekozenVariant(v));
        const namen = [this.dataset.kort || '', ...gekozen.map(v => v.dataset.titel || '')].filter(Boolean).join(' ' + (t.en || 'en') + ' ');
        let tekst, naam = '';
        if (r.knop === 'deal') {
          // Black Friday (Geert 31-10-2026): tijdens de campagne "Pak je Black Friday deal" (knopDealBf, alleen gevuld tijdens de
          // campagne en in het Nederlands; in de Black Friday-bundel "Pak je Black Friday bundel"), na het einde (html.bf-voorbij,
          // ook bij een pagina uit de cache) de gewone tekst.
          const bf = t.knopDealBf && !voorbij ? t.knopDealBf : '';
          tekst = bf || t.knopDeal || '';
          naam = (t.knopDealNaam || '').replace('{producten}', namen).replace('{bedrag}', geld(r.totaal, t.geld));
          if (bf && t.knopDeal) naam = naam.replace(t.knopDeal, bf);
        } else if (r.knop === 'gewoon' && bundel && bundel.knopGewoon) {
          // De 20% schuift alleen (BESLUITEN 14b): wel de bundel, geen dealbelofte; naam met inhoud en bundelprijs.
          tekst = bundel.knopGewoon;
          naam = (t.knopDealNaam || '').replace('{producten}', namen).replace('{bedrag}', geld(r.totaal, t.geld));
          if (t.knopDeal) naam = naam.replace(t.knopDeal, bundel.knopGewoon);
        } else if (r.knop === 'gewoon') tekst = (t.knop || '').replace('{aantal}', this.aantal() + gekozen.length);
        // Sinds 20-10-2026 rekent ook de brilpagina met de actie (Geert: "bril + product of product + bril is wel 2e 20%").
        else tekst = this.actief() && this.instelling.pct > 0 && this.aantal() < 2 ? t.knopKies : t.knopLeeg;
        if (this.knop.getAttribute('aria-busy') !== 'true') this.knop.disabled = r.knop === 'leeg';
        if (tekst) zetTekst(this.knop, tekst);
        if (naam) { if (this.knop.getAttribute('aria-label') !== naam) this.knop.setAttribute('aria-label', naam); } else this.knop.removeAttribute('aria-label');
      }
      this.classList.toggle('is-gekozen', r.knop !== 'leeg');
    }
    // Black Friday-bundel (ronde 6; snippets/banky-complete-addons.liquid rendert de eerste stand met dezelfde teksten):
    // "Bundelprijs" zodra er iets aan staat (anders "Totaal"), "Je bespaart" met stand.bespaar (zijn plek blijft, data-leeg)
    // en de naam van de vaste regel bij aantal en winkelwagen ("Deze powerbank", "2x deze powerbank", "Nog een powerbank").
    tekenBundel(r, b, voorbij) {
      const aan = r.knop !== 'leeg';
      zetTekst(this.querySelector('.banky-compleet__totaal-label'), aan && !voorbij ? b.prijs : b.totaal);
      const winst = this.querySelector('[data-bfb-winst]');
      if (winst) {
        zetTekst(winst, b.winst + ' ' + geld(r.bespaar, this.tekst.geld));
        // Zichtbaar zodra er iets te besparen valt, ook zonder extra (2 stuks, of de van-prijs van het hoofdproduct), net als
        // "Bespaar" in het gewone blok (BESLUITEN §51, Geert 31-10-2026: "altijd vanaf de van-prijs hoogste korting laten zien").
        const leeg = !(r.bespaar > 0);
        if (winst.hasAttribute('data-leeg') !== leeg) winst.toggleAttribute('data-leeg', leeg);
      }
      const n = this.aantal(), nog = !!(this.wagenHandles && this.wagenHandles.has(b.handle));
      const naam = ((b.namen || [])[(nog ? 2 : 0) + (n > 1 ? 1 : 0)] || '').replace('{aantal}', n);
      if (naam) zetTekst(this.querySelector('[data-bfb-hoofd-naam]'), naam);
    }
    // De ene prijsregel (snippets/banky-prijsregel.liquid): dealprijs of prijs, doorgestreept de van-prijs, "Bespaar".
    zetPrijsregel(regel, x) {
      if (!regel || !x) return;
      const t = this.tekst;
      zetTekst(regel.querySelector('[data-banky-pr-sr]'), (x.deal ? t.srDealprijs : t.srPrijs) + ' ');
      zetTekst(regel.querySelector('[data-banky-pr-nu]'), geld(x.nu, t.geld));
      zetVerborgen(regel.querySelector('[data-banky-pr-van]'), !x.door);
      zetTekst(regel.querySelector('[data-banky-pr-door]'), x.door ? geld(x.door, t.geld) : '');
      const bespaar = x.bespaarIn === 'euro' && x.bespaarEuro > 0 ? geld(x.bespaarEuro, t.geld) : x.bespaarIn === 'pct' && x.bespaarPct > 0 ? x.bespaarPct + '%' : '';
      const label = regel.querySelector('[data-banky-pr-bespaar]');
      zetTekst(label, bespaar ? (t.bespaar || '').replace('{savings}', bespaar) : '');
      zetVerborgen(label, !bespaar);
    }
    meetWeergave() {
      const zend = () => meet('banky_upsell_view', {banky_plek: 'koopbox', banky_product: this.dataset.product || '', banky_vooraf: this.voorafVink ? this.voorafVink.value || '' : '', banky_deal: !!this.actief(), banky_pct: this.instelling.pct});
      if (!('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver(items => { if (items.some(x => x.isIntersecting)) { io.disconnect(); zend(); } }, {threshold: 0.5});
      io.observe(this);
    }
    async voegToe() {
      const gekozen = this.extra().filter(v => v.checked && gekozenVariant(v));
      if (!gekozen.length || !this.dataset.hoofd) return;
      const r = this.stand || {};
      const voorafBehouden = !!(this.voorafVink && this.voorafVink.checked);
      // _bron: welke plek de aanvuller verkocht (zichtbaar in de bestelling, niet in lade en kassa: eigenschappen met _).
      // Het hoofdproduct krijgt geen eigenschap, zodat het samenvoegbaar blijft met de gewone koopknop.
      const items = [{id: Number(this.dataset.hoofd), quantity: this.aantal()}, ...gekozen.map(v => ({id: Number(v.value), quantity: 1, properties: {_bron: v === this.voorafVink ? 'koopbox-vooraf' : 'koopbox'}}))];
      meet('banky_upsell_klik', {banky_plek: 'koopbox', banky_product: this.dataset.product || '', banky_varianten: items.map(i => String(i.id)), banky_totaal: r.totaal || 0, banky_extra_korting: Math.max(0, r.extraKorting || 0), banky_vooraf_behouden: voorafBehouden});
      const form = document.forms[this.dataset.form] || document.getElementById(this.dataset.form);
      this.toonMelding('');
      this.knop.disabled = true;
      this.knop.setAttribute('aria-busy', 'true');
      let gemeld = false;
      try {
        // Lokale preview: de demo-winkelwagen (alleen preview) kan meerdere regels tegelijk tonen.
        if (window.BankyDemoCart && typeof window.BankyDemoCart.addItems === 'function') {
          await window.BankyDemoCart.addItems(items.map(i => ({variant: i.id, qty: i.quantity})));
          return;
        }
        const secties = ['variant-added'];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {bubbles: true, detail: {sections: secties}}));
        const antwoord = await fetch(wortel() + 'cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
          body: JSON.stringify({items, sections: secties.join(','), sections_url: wortel() + 'variants/' + this.dataset.hoofd}),
        });
        const json = await antwoord.json();
        if (!antwoord.ok) { gemeld = true; meet('banky_upsell_fout', {banky_plek: 'koopbox', banky_status: antwoord.status}); throw new Error(json && json.description); }
        const cart = await (await fetch(wortel() + 'cart.js')).json();
        cart.sections = json.sections;
        // Na een geslaagde "Pak je deal" alles uit, zoals sinds WP2.1; daarna rekent de koopbox met de nieuwe winkelwagen.
        this.extra().forEach(v => { v.checked = false; });
        (form || this).dispatchEvent(new CustomEvent('variant:add', {bubbles: true, detail: {items: json.items || [json], cart, hoofd: Number(this.dataset.hoofd)}}));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {bubbles: true, detail: {baseEvent: 'variant:add', cart}}));
      } catch (fout) {
        if (!gemeld) meet('banky_upsell_fout', {banky_plek: 'koopbox', banky_status: 'netwerk'});
        this.toonMelding((fout && fout.message) || this.tekst.fout);
      } finally {
        this.knop.removeAttribute('aria-busy');
        this.reken();
      }
    }
  }
  if (!customElements.get('banky-complete')) customElements.define('banky-complete', BankyComplete);

  /* ---- Sticky balk ------------------------------------------------------------------------------------------- */
  /* Soepel scrollen (Geert 20-10-2026: "check ook het scrollen op product pagina web secties gaat soms een beetje stotterend"; keuze
     "Volledig soepel (Aanbevolen)"). De balk en de meelopende delen (inhoudsopgave van de omschrijving, samenvatting van de reviews)
     volgen de kop niet meer per frame. Tot 21-10 liep hier een lus zolang store-header animeerde (getAnimations) die per frame
     --banky-pdp-boven op :root zette; elke schrijfactie op :root dwong een stijlronde over de hele pagina af (circa 2.000 elementen,
     9 tot 15 ms, bij 4x CPU 38 tot 93 ms), 12 tot 15 frames lang bij elke kopwissel. Nu:
     - de maten (onderkant van de kop in rust en weggeschoven, hoogte van de balk) alleen bij het laden, bij resize en als de balk
       van hoogte verandert;
     - een MutationObserver ziet de klassen is-banky-weg en is-banky-snel op store-header (banky-header-kop.js blok 4) en is-visible
       op de balk. Dan zet dit script data-banky-kop (weg, snel of leeg) op de balk en --banky-pdp-boven op de meelopende delen zelf,
       nooit op :root. Zelfde waarden als eerst: 8px onder de kop of 12px van boven, plus de balk als die er is;
     - de balk beweegt met een CSS-overgang op translate (compositor), met dezelfde duur en curve als de kop
       (snippets/banky-header-float.liquid; assets/banky-pagina-product.css, blok soepel scrollen);
     - de meelopende delen krijgen hun nieuwe top meteen. Alleen een deel dat in of vlak bij beeld is en daardoor echt verschuift,
       glijdt van zijn oude plek naar de nieuwe met een Web Animation op translate (compositor), met dezelfde duur en curve als de kop
       (volgTijd hieronder). Toets 21-10: een overgang op top liep op de main thread, ook voor delen buiten beeld, bij elke kopwissel;
       dat liet bij de eerste scroll meer compositorframes wegvallen dan live;
     - de actieve tab komt uit een IntersectionObserver met de lijn als onderrand, in plaats van getBoundingClientRect per frame.
     Onder 1000px staat de balk onderaan en wordt er niets gezet, zoals eerst. */
  function sticky() {
    const balk = document.querySelector('[data-banky-sticky]');
    if (!balk || balk.dataset.bankyKlaar) return;
    balk.dataset.bankyKlaar = '1';
    const nav = balk.querySelector('[data-banky-tabs]');
    const tabs = [];
    nav?.querySelectorAll('a[data-doelen]').forEach(a => {
      const doel = a.dataset.doelen.split(',').map(s => { try { return document.querySelector(s.trim()); } catch { return null; } }).find(Boolean);
      if (!doel || !doel.id) { a.remove(); return; }
      a.setAttribute('href', '#' + doel.id);
      tabs.push({a, doel});
    });
    if (nav && tabs.length >= 2) nav.hidden = false;
    const kop = document.querySelector('store-header');
    const kopOnder = () => {
      if (!kop) return 0;
      const r = kop.getBoundingClientRect();
      return Math.max(0, Math.round(r.bottom));
    };
    const breed = matchMedia('(min-width: 1000px)');
    const blok = matchMedia('screen and (max-width: 1149px)');
    const VOLGERS = '.banky-leeszone__zij, .banky-product-reviews__head, .banky-leeszone__kaart--winkel, .banky-downloads';
    // Onderkant van de kop als hij vast staat, in rust en weggeschoven (zonder de transform van een lopende overgang), en de hoogte
    // van de balk. Alleen lezen; schrijven gebeurt daarna in zet().
    let maat = null;
    const meet = () => {
      let rust = 0, weg = 0;
      if (kop) {
        const sectie = kop.closest('.shopify-section') || kop.parentElement;
        const kr = kop.getBoundingClientRect(), sr = sectie.getBoundingClientRect(), tf = getComputedStyle(kop).transform;
        let ty = 0;
        if (tf && tf !== 'none') { try { ty = new DOMMatrixReadOnly(tf).m42 || 0; } catch {} }
        const plak = parseFloat(getComputedStyle(sectie).top) || 0, binnen = kr.top - ty - sr.top;
        rust = Math.max(0, Math.round(plak + binnen + kop.offsetHeight));
        // Vanaf 1150px schuift de kop zijn eigen hoogte omhoog, tot en met 1149px balk en kop samen (banky-header-float.liquid).
        weg = Math.max(0, Math.round(blok.matches ? binnen : plak + binnen));
      }
      return {rust, weg, h: Math.round(balk.querySelector('.banky-sticky__balk')?.getBoundingClientRect().height || 60)};
    };
    // Actieve tab: de laatste tab waarvan het doel met zijn bovenkant de lijn heeft bereikt (zoals eerst). De wortel loopt van ver
    // boven het scherm tot de lijn, dus een doel snijdt zodra zijn bovenkant boven de lijn staat. Nieuw bij een andere lijn of hoogte.
    const voorbij = new Set();
    let io = null, ioSleutel = '';
    const tabsVolgen = lijn => {
      if (!tabs.length || !('IntersectionObserver' in window)) return;
      const sleutel = lijn + '|' + innerHeight;
      if (sleutel === ioSleutel) return;
      ioSleutel = sleutel;
      io?.disconnect();
      voorbij.clear();
      io = new IntersectionObserver(items => {
        for (const x of items) { if (x.isIntersecting) voorbij.add(x.target); else voorbij.delete(x.target); }
        let actief = null;
        for (const t of tabs) if (voorbij.has(t.doel)) actief = t;
        for (const t of tabs) { const aan = t === actief; if (aan !== t.a.hasAttribute('aria-current')) { if (aan) t.a.setAttribute('aria-current', 'true'); else t.a.removeAttribute('aria-current'); } }
      }, {rootMargin: `100000px 0px ${Math.round(lijn - innerHeight)}px 0px`});
      tabs.forEach(t => io.observe(t.doel));
    };
    // Meelopende delen die kunnen verschuiven (sticky met top uit --banky-pdp-boven). Alleen wat in of vlak bij beeld is, wordt bij
    // een wissel gemeten en geanimeerd: buiten beeld verschuift een top-wijziging niets wat je ziet.
    const SCHUIVERS = '.banky-leeszone__zij, .banky-product-reviews__head';
    const rustig = matchMedia('(prefers-reduced-motion: reduce)');
    const inBeeld = new Set(), glijdt = new WeakMap(), gezien = new WeakSet();
    const zicht = 'IntersectionObserver' in window ? new IntersectionObserver(l => { for (const x of l) { if (x.isIntersecting) inBeeld.add(x.target); else inBeeld.delete(x.target); } }, {rootMargin: '50% 0px'}) : null;
    const kijkMee = () => { if (zicht) document.querySelectorAll(SCHUIVERS).forEach(el => { if (!gezien.has(el)) { gezien.add(el); zicht.observe(el); } }); };
    // Duur en curve gelijk aan de kop (snippets/banky-header-float.liquid) en de balk (banky-pagina-product.css): weg .2s ease, terug
    // .25s ease-out, tot en met 1149px weg .3s cubic-bezier(.4,0,.2,1) en terug .6s ease-out, snel terug overal .2s ease-out.
    const volgTijd = stand => stand === 'snel' ? [200, 'ease-out'] : blok.matches ? (stand === 'weg' ? [300, 'cubic-bezier(.4,0,.2,1)'] : [600, 'ease-out']) : (stand === 'weg' ? [200, 'ease'] : [250, 'ease-out']);
    // Stand van kop en balk naar attribuut en waarden. Alleen schrijven wat verandert. De eerste keer zonder data-banky-kop en zonder
    // glijden, zodat de balk en de delen bij het laden niet met een beweging op hun plek komen; een beeldje later mag het wel.
    // Glijden alleen bij een wissel van kop of balk (niet bij resize of een andere balkhoogte: dan meteen op de nieuwe plek).
    let vorige = '', animeer = false;
    const zet = opnieuw => {
      if (!maat) return;
      const weg = !!kop && kop.classList.contains('is-banky-weg');
      const stand = weg ? 'weg' : kop && kop.classList.contains('is-banky-snel') ? 'snel' : '';
      const aan = balk.classList.contains('is-visible'), groot = breed.matches;
      const sleutel = [stand, aan, groot, animeer].join('|');
      if (!opnieuw && sleutel === vorige) return;
      vorige = sleutel;
      const onder = weg ? maat.weg : maat.rust;
      const boven = onder > 0 ? onder + 8 : 12;
      const bezet = (aan && groot ? boven + maat.h : onder) + 'px';
      const rustBoven = maat.rust > 0 ? maat.rust + 8 : 12, wegBoven = maat.weg > 0 ? maat.weg + 8 : 12;
      const volgers = [...document.querySelectorAll(VOLGERS)];
      // Lezen: de plek op het scherm van elk deel in beeld dat een andere top krijgt (met een lopende glijbeweging erin).
      const schuif = groot && animeer && !opnieuw && !rustig.matches ? volgers.filter(el => inBeeld.has(el) && el.animate && el.style.getPropertyValue('--banky-pdp-boven') !== bezet) : [];
      const voor = schuif.map(el => el.getBoundingClientRect().top);
      // Schrijven.
      schuif.forEach(el => glijdt.get(el)?.cancel());
      if (balk.style.getPropertyValue('--banky-sticky-boven') !== rustBoven + 'px') balk.style.setProperty('--banky-sticky-boven', rustBoven + 'px');
      if (balk.style.getPropertyValue('--banky-sticky-schuif') !== (wegBoven - rustBoven) + 'px') balk.style.setProperty('--banky-sticky-schuif', (wegBoven - rustBoven) + 'px');
      if (animeer && balk.getAttribute('data-banky-kop') !== stand) balk.setAttribute('data-banky-kop', stand);
      volgers.forEach(el => {
        if (!groot) { glijdt.get(el)?.cancel(); el.style.removeProperty('--banky-pdp-boven'); return; }
        if (el.style.getPropertyValue('--banky-pdp-boven') !== bezet) el.style.setProperty('--banky-pdp-boven', bezet);
      });
      // Opnieuw lezen en laten glijden: van de oude plek (verschil als translate) naar 0, op de compositor.
      if (schuif.length) {
        const [duur, curve] = volgTijd(stand);
        const na = schuif.map(el => el.getBoundingClientRect().top);
        schuif.forEach((el, i) => {
          const d = Math.round((voor[i] - na[i]) * 10) / 10;
          if (Math.abs(d) >= 0.5) glijdt.set(el, el.animate([{translate: `0 ${d}px`}, {translate: '0 0'}], {duration: duur, easing: curve}));
        });
      }
      tabsVolgen(boven + 60 + 48);
    };
    const kijker = new MutationObserver(() => zet(false));
    if (kop) kijker.observe(kop, {attributes: true, attributeFilter: ['class']});
    kijker.observe(balk, {attributes: true, attributeFilter: ['class']});
    let gepland = 0;
    const herMeet = () => {
      gepland = 0;
      const eerste = !maat;
      kijkMee();
      maat = meet();
      zet(true);
      if (eerste) requestAnimationFrame(() => requestAnimationFrame(() => { animeer = true; zet(true); }));
    };
    const plan = () => { if (!gepland) gepland = requestAnimationFrame(herMeet); };
    addEventListener('resize', plan, {passive: true});
    breed.addEventListener?.('change', plan);
    blok.addEventListener?.('change', plan);
    // De balk zelf kan van hoogte veranderen (andere variant, prijsregel); de eerste melding komt na de eerste layout en meet dan.
    const balkVak = balk.querySelector('.banky-sticky__balk');
    if (balkVak && 'ResizeObserver' in window) new ResizeObserver(plan).observe(balkVak); else plan();
    nav?.addEventListener('click', e => {
      const a = e.target.closest('a[href^="#"]');
      const t = a && tabs.find(x => x.a === a);
      if (!t) return;
      e.preventDefault();
      const y = t.doel.getBoundingClientRect().top + scrollY - (balk.getBoundingClientRect().height + 24);
      scrollTo({top: Math.max(0, y), behavior: vloeiend() ? 'smooth' : 'auto'});
    });
    balk.querySelector('[data-banky-sticky-alternatieven]')?.addEventListener('click', e => {
      const doel = document.getElementById('alternatieven');
      if (!doel) return;
      e.preventDefault();
      const y = doel.getBoundingClientRect().top + scrollY - (kopOnder() + 24);
      scrollTo({top: Math.max(0, y), behavior: vloeiend() ? 'smooth' : 'auto'});
    });
  }

  /* ---- Titel: getal en eenheid op één regel ----------------------------------------------------------------------
     De H1 wordt gebalanceerd afgebroken (text-wrap: balance, geen los slotwoord); daarbij viel soms "mAh" los van zijn
     getal ("Powerbank 30.000 | mAh 22,5W"). Alleen de spatie tussen getal en eenheid wordt een vaste spatie: de tekst en
     de HTML blijven gelijk (fase 2-3 QA). Sinds WP na-live-product.1 (17-10-2026) zet snippets/banky-titel-eenheden.liquid
     de vaste spatie al in de HTML van de server (anders brak de H1 na de eerste weergave opnieuw af: CLS); dit blijft het
     vangnet. */
  function titelEenheden() {
    document.querySelectorAll('.product-info__title').forEach(h => {
      h.childNodes.forEach(n => {
        if (n.nodeType === 3 && /\d (?:mAh|Wh)\b/.test(n.data)) n.data = n.data.replace(/(\d) (mAh|Wh)\b/g, '$1\u00a0$2');
      });
    });
  }

  /* ---- Zet me op de lijst: Banky's eigen formulier, zonder Omnisend-popup en zonder handwerk (Geert 05-10-2026) ------
     Geert: "deze pop up komt ook op terwijl de tweede hoort te weergeven toch? check en fix", "ik zie nog steeds dit live die
     pop up ging toch weg?" en daarna "okee maar wat ik gewoon wil is geen handmatige handelingen en automatische mailing bij
     voorraad hoe moeilijk is dat". A's knop (data-banky-bis-open, buy-buttons) toont direct het blok "Houd me op de hoogte"
     (banky-bis-terugval) van dezelfde koopbox en zet de cursor in het veld. Tikt de klant voordat dit script geladen is, dan
     doet het script in buy-buttons dat al (data-getoond); het script in banky-bis-terugval houdt een verzending dan vast
     (data-wacht) en onthoudt echte invoer (data-echt); dit script verstuurt hem zodra het er is. Draait dit script na het
     laden van de pagina toch niet (niet geladen, te oude browser, fout), dan verstuurt dat inline script hem zelf
     (noodroute, toets 06-10).
     Met JavaScript gaat elke aanmelding naar Omnisend en nooit naar /contact (geen mail die de winkel met de hand moet
     afhandelen). Hetzelfde verzoek als hun popup (forms-main.js, opgehaald 05-10): POST backInStockNotify met JSON als tekst
     en zonder Content-Type (eenvoudig CORS-verzoek), met product, gekozen variant, merk, formulier, paginagegevens, het adres
     en het Omnisend-cookie als dat er is. Elk 2xx-antwoord zonder "error" is gelukt (toets 06-10: ook een leeg of onverwacht
     antwoord heeft Omnisend al verwerkt, dus niet nog eens versturen): de klant staat dan in Omnisend's "Back in stock
     requests" en de automatisering "Product back in stock" mailt bij herbevoorrading.
     - Korter dan 0,8 s na tonen verzonden, of nog zonder echte invoer: de knop blijft bezig tot 0,8 s om is, dan versturen.
       Een vastgehouden verzending wordt eerst opnieuw gecontroleerd: is het veld intussen leeg of ongeldig, dan niets.
     - Lokveld (bis_controle) ingevuld zonder enige echte (isTrusted) tik of toets in het formulier: niets versturen, wel de
       bevestiging. Lokveld ingevuld met echte invoer (bijvoorbeeld automatisch invullen): gewoon naar Omnisend.
     - Geen antwoord binnen 8 s, netwerkfout of blokkade, 5xx, 408 of 429: opnieuw met hetzelfde verzoek, in totaal drie
       pogingen, met 0,6 en 1,5 s pauze. De knop blijft al die tijd bezig met aria-busy en aria-disabled, niet disabled: zo
       blijft de focus op de knop (een tweede verzending houdt bezigNu tegen). Na 1,5 s staat de bezigtekst in de rij van de
       privacyregel (data-banky-bis-bezig, role="status").
     - 400, 422 of JSON met error: niet opnieuw, melding "fout" (met aria-invalid op het veld). Een andere 4xx (zoals een 403
       van Cloudflare): niet opnieuw, melding "mislukt". Na drie mislukte pogingen, of als er echt geen variant te vinden is:
       melding "mislukt". Waren dat drie netwerkfouten, dan eerst de oorzaak (bisOorzaak): blokkeert de browser Omnisend
       (trackingbescherming van Firefox of Edge, een adblocker), dan melding "geblokkeerd", want opnieuw proberen helpt dan
       nooit. Alle meldingen met role="alert" in de rij van de privacyregel (vaste hoogte); de focus blijft waar hij is (een
       focus naar het veld las de melding twee keer voor), het adres blijft staan en opnieuw verzenden kan. Nieuwe invoer of
       een andere variant haalt de melding weg.
     - Telling zonder persoonsgegevens (nooit het adres): dataLayer-event banky_voorraadmelding met banky_status (gelukt,
       mislukt of lokveld), banky_reden, banky_pogingen en banky_variant (het variant-id).
     Shopify's hCaptcha zet zich niet op dit formulier (data-nocaptcha="true"). De verzendluisteraar staat bovendien in de
     vangfase op document, dus vóór elke luisteraar op het formulier (zoals die van hCaptcha) en vóór captcha-bootstrap (op
     document, bubbelfase), en stopt ze allemaal. Variant: die van de laatste variantwissel van de koopbox, anders het id-veld
     van het productformulier, dan ?variant=, dan de hint <variant-selection>, dan de variant uit de HTML (contact[Variant]),
     en bij een product met één variant die; alleen een variant van dit product (data-varianten) telt. Aangemeld wordt per
     verzonden variant onthouden: kiest de klant een andere variant, dan staat het formulier weer klaar; terug naar een
     aangemelde variant toont de bevestiging. Een wissel tijdens het verzenden telt voor de verzonden variant; daarna volgt het
     blok de gekozen variant (toets 06-10: geen bevestiging onder een variant die niet is aangemeld).
     Snelkooplade (toets 06-10): daar staat geen formulier, dus de knop opent de productpagina op ?variant=<id>#banky-bis-terugval
     (banky-cards.js); dit script opent het blok dan meteen, alleen als die variant uitverkocht is. */
  const BIS_MIN_MS = 800, BIS_WACHT_MS = 8000, BIS_POGINGEN = 3, BIS_PAUZE_MS = [600, 1500], BIS_GEDULD_MS = 1500;
  const BIS_OMNISEND = 'https://forms.soundestlink.com/REST/forms/v2/backInStockNotify';
  const bisBlokken = new WeakMap();
  const koekje = naam => {
    try { const m = document.cookie.match(new RegExp('(?:^|; )' + naam + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : undefined; } catch { return undefined; }
  };
  // Het blok van een knop: dat van zijn koopbox; voor de knop in de sticky balk (eigen quick-buy-formulier) dat van het hoofdformulier.
  // De knop in een snelkooplade hoort bij een ander product: geen blok hier (banky-cards.js opent dan de productpagina).
  const bisBlokVan = knop => {
    if (knop.closest('quick-buy-drawer')) return null;
    const box = [knop.closest('buy-buttons'), knop.closest('product-quick-add[form]')]
      .map(el => el && el.getAttribute('form')).filter(Boolean)
      .map(id => perForm('[data-banky-koopbox][data-form="%"]', id)[0]).find(Boolean) || knop.closest('[data-banky-koopbox]');
    return box ? box.querySelector('[data-banky-bis-terugval]') : null;
  };
  // aria-controls en aria-expanded van de knoppen die dit blok openen.
  const bisKnoppen = blok => {
    document.querySelectorAll('[data-banky-bis-open]').forEach(knop => {
      if (bisBlokVan(knop) !== blok) return;
      if (blok.id) knop.setAttribute('aria-controls', blok.id);
      knop.setAttribute('aria-expanded', String(!blok.hidden));
    });
  };
  // Variantwissel (zetBeschikbaar): de hint voor Omnisend bijwerken en het blok de gekozen variant geven ('' = geen geldige variant).
  function bisVariant(box, variant) {
    const id = variant && variant.id ? String(variant.id) : '';
    if (id) box.querySelectorAll('[data-banky-omnisend-variant]').forEach(el => el.setAttribute('variant', id));
    box.querySelectorAll('[data-banky-bis-terugval]').forEach(blok => {
      blok.dataset.variant = id;
      blok.dataset.variantTitel = id && variant.title && variant.title !== 'Default Title' ? variant.title : '';
      bisBlokken.get(blok)?.opnieuw(id);
      bisKnoppen(blok);
    });
  }
  // Telling zonder persoonsgegevens, zoals de winkel elders naar de dataLayer schrijft (window.dataLayer, eventnaam banky_...).
  const bisTel = (status, reden, pogingen, variant) => {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({event: 'banky_voorraadmelding', banky_status: status, banky_reden: reden || '', banky_pogingen: pogingen, banky_variant: variant || ''});
    } catch { /* de telling mag de aanmelding nooit hinderen */ }
  };
  // Eén poging bij Omnisend. Lost altijd op: {gelukt: true} of {opnieuw, reden}. Redenen fout_<code> en fout_omnisend zijn een
  // invoerfout (melding "fout"), al het andere is "mislukt". Ook een fetch-omhulsel van een app dat meteen gooit, wordt een netwerkfout.
  const bisPoging = body => {
    const stop = typeof AbortController === 'function' ? new AbortController() : null;
    let klok = 0;
    const tijd = new Promise(klaar => {
      klok = setTimeout(() => { try { stop?.abort(); } catch { /* al klaar */ } klaar({opnieuw: true, reden: 'tijd'}); }, BIS_WACHT_MS);
    });
    const antwoord = Promise.resolve()
      .then(() => fetch(BIS_OMNISEND, {method: 'POST', body, signal: stop ? stop.signal : undefined}))
      .then(r => {
        const s = r.status;
        if (s >= 500 || s === 408 || s === 429) return {opnieuw: true, reden: 'status_' + s};
        if (s === 400 || s === 422) return {opnieuw: false, reden: 'fout_' + s};
        if (s < 200 || s > 299) return {opnieuw: false, reden: 'status_' + s};
        return r.text().catch(() => '').then(tekst => {
          let j = null;
          try { j = JSON.parse(tekst); } catch { /* geen JSON: toch gelukt */ }
          return j && typeof j === 'object' && j.error ? {opnieuw: false, reden: 'fout_omnisend'} : {gelukt: true};
        });
      })
      .catch(fout => ({opnieuw: true, reden: fout && fout.name === 'AbortError' ? 'tijd' : 'netwerk'}));
    return Promise.race([antwoord, tijd]).finally(() => clearTimeout(klok));
  };
  // Na drie netwerkfouten de oorzaak (toets 06-10: Firefox, in privévensters al standaard, en Edge Strict blokkeren
  // soundestlink.com via de Disconnect-lijst). Twee kleine verzoeken zonder gegevens: de eigen winkel (/robots.txt) en hetzelfde
  // Omnisend-adres als HEAD zonder CORS (no-cors: elk antwoord, ook een fout, bewijst dat de browser het doorlaat). Eigen winkel
  // onbereikbaar: netwerk. Omnisend bereikbaar: het antwoord op de aanmelding was niet leesbaar (bijvoorbeeld een 403 van
  // Cloudflare zonder CORS-kop): cors. Anders blokkeert de browser Omnisend: geblokkeerd.
  const bisOorzaak = () => {
    if (navigator.onLine === false) return Promise.resolve('netwerk');
    const bereikbaar = (url, opties) => Promise.race([
      Promise.resolve().then(() => fetch(url, {cache: 'no-store', ...opties})).then(() => true, () => false),
      new Promise(klaar => setTimeout(() => klaar(false), 4000)),
    ]);
    return Promise.all([
      bereikbaar(location.origin + '/robots.txt', {credentials: 'same-origin'}),
      bereikbaar(BIS_OMNISEND, {method: 'HEAD', mode: 'no-cors', credentials: 'omit'}),
    ]).then(([eigen, omni]) => (!eigen ? 'netwerk' : omni ? 'cors' : 'geblokkeerd'));
  };
  function bisTerugval() {
    const richtIn = blok => {
      if (bisBlokken.has(blok)) return bisBlokken.get(blok);
      const form = blok.querySelector('[data-banky-bis-terugval-form]');
      const gelukt = blok.querySelector('[data-banky-bis-terugval-gelukt]');
      const veld = blok.querySelector('input[type="email"]');
      if (!form || !veld) return null;
      const lok = blok.querySelector('[data-banky-bis-lok]');
      const variantVeld = form.querySelector('[data-banky-bis-variant]');
      const meldingVak = form.querySelector('[data-banky-bis-melding]');
      const meldingTekst = meldingVak && meldingVak.querySelector('[data-banky-bis-melding-tekst]');
      const statusVak = form.querySelector('[data-banky-bis-bezig]');
      const verzendKnop = form.querySelector('[type="submit"]');
      // De teksten (banky_ui.wp2_1.terugval) staan als attribuut op het element dat ze als onzichtbare maat gebruikt (CSS).
      const tekst = soort => { const el = form.querySelector('[data-' + soort + ']'); return (el && el.getAttribute('data-' + soort)) || ''; };
      const aangemeld = new Set();
      let getoond = 0, eerste = 0, echt = false, bezigNu = false, geduld = 0, vorigeVariant = blok.dataset.variant || '';
      const zichtbaar = aan => { blok.hidden = !aan; bisKnoppen(blok); };
      const bezig = aan => {
        bezigNu = aan;
        clearTimeout(geduld);
        delete form.dataset.geduld;
        if (statusVak) statusVak.textContent = '';
        if (aan && statusVak) geduld = setTimeout(() => { if (bezigNu) { statusVak.textContent = tekst('bezig'); form.dataset.geduld = ''; } }, BIS_GEDULD_MS);
        if (!verzendKnop) return;
        verzendKnop.disabled = false;
        ['aria-disabled', 'aria-busy'].forEach(a => (aan ? verzendKnop.setAttribute(a, 'true') : verzendKnop.removeAttribute(a)));
      };
      const variantNu = () => {
        const toegestaan = (form.dataset.varianten || '').split(',').filter(Boolean);
        const geldig = v => /^\d+$/.test(String(v || '')) && (!toegestaan.length || toegestaan.includes(String(v)));
        const box = blok.closest('[data-banky-koopbox][data-form]');
        const pf = box ? document.forms[box.dataset.form] || document.getElementById(box.dataset.form) : null;
        const kandidaten = [blok.dataset.variant];
        if (pf && pf.elements) [...pf.elements].forEach(el => { if (el.name === 'id' && !el.disabled) kandidaten.push(el.value); });
        kandidaten.push(new URLSearchParams(location.search).get('variant'));
        kandidaten.push((box || document).querySelector('[data-banky-omnisend-variant]')?.getAttribute('variant'));
        kandidaten.push(variantVeld && variantVeld.dataset.id);
        if (toegestaan.length === 1) kandidaten.push(toegestaan[0]);
        return kandidaten.find(geldig) || '';
      };
      // Melding in de rij van de privacyregel (die rij heeft vast de hoogte van de langste melding, dus niets verspringt).
      const melding = soort => {
        const t = meldingVak ? tekst(soort) : '';
        if (!t) return;
        if (meldingTekst) meldingTekst.textContent = t; else meldingVak.textContent = t;
        form.dataset.melding = soort;
        if (soort === 'fout') veld.setAttribute('aria-invalid', 'true'); else veld.removeAttribute('aria-invalid');
        if (meldingVak.id) veld.setAttribute('aria-describedby', meldingVak.id);
        if (blok.hidden || form.hidden) return;
        // Ruim in beeld: onderaan kunnen de WhatsApp-knop en de sticky balk de melding bedekken. De focus blijft waar hij is.
        const f = form.getBoundingClientRect(), r = meldingVak.getBoundingClientRect();
        if (f.top < 0 || r.bottom > innerHeight - 120) form.scrollIntoView({block: 'center', behavior: vloeiend() ? 'smooth' : 'auto'});
      };
      const geenMelding = () => {
        if (!form.dataset.melding) return;
        delete form.dataset.melding;
        if (meldingTekst) meldingTekst.textContent = '';
        veld.removeAttribute('aria-invalid');
        veld.removeAttribute('aria-describedby');
      };
      // Bevestiging in plaats van het formulier, zo hoog als de tekst. Tot 16-10-2026 was het vak even hoog als het formulier
      // (min-height), zodat de alternatieven eronder niet verschoven; op Geerts schermafbeelding (Ss3, 16-10) was dat een groot
      // leeg tintvlak rond één zin. Nu schuift wat eronder staat op na de aanmelding, een eigen actie van de klant.
      const bevestiging = variant => {
        if (variant) aangemeld.add(variant);
        bezig(false);
        geenMelding();
        form.hidden = true;
        if (!gelukt) return;
        const tekst = gelukt.querySelector('[data-banky-bis-terugval-tekst]');
        if (tekst) tekst.textContent = gelukt.dataset.tekst || '';
        gelukt.hidden = false;
      };
      // Was het blok intussen dicht (de klant koos een variant die wel op voorraad is), dan blijft het dicht tot de volgende tik.
      const klaar = (variant, scrollen) => {
        const open = !blok.hidden;
        bevestiging(variant);
        if (!open && !scrollen) return;
        zichtbaar(true);
        if (gelukt) { gelukt.tabIndex = -1; gelukt.focus({preventScroll: !scrollen}); }
      };
      // Het formulier weer klaarzetten (andere variant dan de aangemelde).
      const herstel = () => {
        form.hidden = false;
        if (gelukt) gelukt.hidden = true;
        getoond = 0;
        if (lok) lok.value = '';
        geenMelding();
      };
      // Formulier of bevestiging voor deze variant, zonder het blok te openen of te sluiten. Tijdens verzenden niets.
      const staatVoor = id => {
        if (bezigNu) return;
        if (id && aangemeld.has(id)) { if (!form.hidden) bevestiging(id); } else if (form.hidden) herstel();
      };
      const verzend = () => {
        if (bezigNu) return;
        geenMelding();
        const variant = variantNu();
        const d = form.dataset;
        const nu = Date.now();
        if (lok && lok.value && !echt && !form.hasAttribute('data-echt')) { klaar(variant); bisTel('lokveld', 'lokveld', 0, variant); return; }
        // Een vastgehouden verzending (data-wacht) is niet door de browser gecontroleerd: het veld kan intussen leeg zijn.
        if (!veld.checkValidity()) { bezig(false); veld.reportValidity(); return; }
        if (!variant || !d.product || !d.omnisendMerk || !d.omnisendFormulier) {
          bezig(false);
          melding('mislukt');
          bisTel('mislukt', variant ? 'gegevens' : 'variant', 0, variant);
          return;
        }
        bezig(true);
        const adres = veld.value.trim();
        const begin = getoond || nu;
        setTimeout(() => {
          const body = JSON.stringify({
            productID: String(d.product),
            variantID: String(variant),
            brandID: d.omnisendMerk,
            formID: d.omnisendFormulier,
            stepIndex: 0,
            pageData: {URL: location.href, title: document.title, timeToSubmit: Date.now() - (eerste || begin)},
            formData: {emailField: adres},
            contactID: '',
            cookieContactID: koekje('omnisendContactID'),
            unconfirmedContactID: '',
          });
          let poging = 0, vorige = '';
          const volgende = () => {
            poging++;
            bisPoging(body).then(uit => {
              if (uit.gelukt) {
                klaar(variant);
                bisTel('gelukt', vorige, poging, variant);
                // Toets 06-10: koos de klant tijdens het verzenden een andere variant, dan geldt de bevestiging alleen de verzonden
                // variant; het blok volgt nu de gekozen variant (formulier, of de bevestiging als die al aangemeld is).
                const nu = blok.dataset.variant || '';
                if (nu && nu !== variant) { vorigeVariant = nu; staatVoor(nu); }
                return;
              }
              vorige = uit.reden;
              if (uit.opnieuw && poging < BIS_POGINGEN) { setTimeout(volgende, BIS_PAUZE_MS[Math.min(poging, BIS_PAUZE_MS.length) - 1]); return; }
              (uit.reden === 'netwerk' ? bisOorzaak().catch(() => 'netwerk') : Promise.resolve(uit.reden)).then(reden => {
                bezig(false);
                melding(/^fout_/.test(reden) ? 'fout' : reden === 'geblokkeerd' ? 'geblokkeerd' : 'mislukt');
                bisTel('mislukt', reden, poging, variant);
              });
            });
          };
          volgende();
        }, Math.max(0, BIS_MIN_MS - (nu - begin)));
      };
      const openen = () => {
        staatVoor(variantNu());
        const was = blok.hidden;
        zichtbaar(true);
        if (form.hidden) { if (gelukt) { gelukt.tabIndex = -1; gelukt.focus({preventScroll: true}); } return; }
        if (was || !getoond) getoond = Date.now();
        // Ruim in beeld, zoals een melding (toets 06-10: met 'nearest' kwam de privacyregel onderaan het scherm onder de WhatsApp-knop).
        // Eerst scrollen, dan de cursor in het veld: in WebKit (iPhone) brak een focus vóór het vloeiend scrollen dat scrollen af.
        const r = blok.getBoundingClientRect();
        if (r.top < 0 || r.bottom > innerHeight - 120) blok.scrollIntoView({block: 'center', behavior: vloeiend() ? 'smooth' : 'auto'});
        veld.focus({preventScroll: true});
      };
      // Variantwissel: een bevestiging van een andere variant gaat dicht (tot de volgende tik), een aangemelde variant toont de
      // bevestiging, en een melding hoort bij de vorige variant (toets 06-10).
      const opnieuw = id => {
        if (bezigNu) return;
        if (id !== vorigeVariant) geenMelding();
        vorigeVariant = id;
        const wasBevestiging = form.hidden;
        staatVoor(id);
        if (wasBevestiging && !form.hidden) zichtbaar(false);
      };
      const b = {openen, opnieuw, verzend};
      bisBlokken.set(blok, b);

      const interactie = () => { if (!eerste) eerste = Date.now(); };
      form.addEventListener('focusin', interactie);
      form.addEventListener('input', interactie);
      // Echte invoer: een tik, klik, toets of invoer van de bezoeker zelf (een script dat value zet en verzendt telt niet).
      const merkEcht = e => { if (e.isTrusted) echt = true; };
      ['pointerdown', 'mousedown', 'touchstart', 'keydown', 'input', 'paste', 'click'].forEach(type => form.addEventListener(type, merkEcht, {capture: true, passive: true}));
      veld.addEventListener('input', geenMelding);

      const hoofd = blok.id === 'banky-bis-terugval' && location.hash === '#banky-bis-terugval';
      if (hoofd && /[?&]contact_posted=true/.test(location.search)) {
        // Terug van de contactroute zonder JavaScript (of van een oudere versie van deze pagina): de bevestiging. Met JavaScript
        // is er niets naar Omnisend gegaan, dus de variant telt niet als aangemeld (een tik op de knop toont het formulier), en
        // de query gaat uit de adresbalk, zodat herladen of delen geen bevestiging zonder aanmelding toont (toets 06-10).
        klaar('', true);
        try {
          const q = new URLSearchParams(location.search);
          q.delete('contact_posted');
          history.replaceState(history.state, '', location.pathname + (q.toString() ? '?' + q : ''));
        } catch { /* geen history: de bevestiging blijft gewoon staan */ }
        // De browser verwerkt bij het laden het #-anker en haalt dan de focus weg (het blok zelf is niet focusbaar): daarna opnieuw.
        if (document.readyState !== 'complete') addEventListener('load', () => setTimeout(() => { if (gelukt && !gelukt.hidden) gelukt.focus({preventScroll: true}); }, 0), {once: true});
      } else if (!blok.hidden && !form.hidden) {
        // Al geopend door het script in buy-buttons (tik vóór dit script): vanaf dat moment telt de invultijd.
        getoond = Number(blok.dataset.getoond) || Date.now();
        eerste = eerste || getoond;
      } else if (hoofd && blok.closest('[data-banky-koopbox]')?.dataset.beschikbaar === 'false') {
        // Vanuit de snelkooplade (banky-cards.js): het formulier meteen open, alleen bij een uitverkochte variant. Ook hier haalt de
        // browser bij het #-anker de focus weg: daarna de cursor terug in het veld, als de klant intussen niets anders koos.
        openen();
        if (document.readyState !== 'complete') addEventListener('load', () => setTimeout(() => { if (!blok.hidden && !form.hidden && document.activeElement === document.body) veld.focus({preventScroll: true}); }, 0), {once: true});
      }
      bisKnoppen(blok);
      // Verzonden voordat dit script er was (vastgehouden door het script in banky-bis-terugval): nu versturen.
      if (form.hasAttribute('data-wacht')) { form.removeAttribute('data-wacht'); verzend(); }
      return b;
    };
    document.querySelectorAll('[data-banky-bis-terugval]').forEach(richtIn);

    // Verzenden: vangfase op document, dus vóór elke luisteraar op het formulier; met JavaScript nooit de gewone verzending.
    document.addEventListener('submit', e => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('[data-banky-bis-terugval-form]')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      const blok = form.closest('[data-banky-bis-terugval]');
      const b = blok && richtIn(blok);
      if (b) b.verzend();
    }, true);
    document.addEventListener('click', e => {
      const knop = e.target.closest && e.target.closest('[data-banky-bis-open]');
      if (!knop) return;
      const blok = bisBlokVan(knop);
      const b = blok && richtIn(blok);
      if (!b) return;
      e.preventDefault();
      b.openen();
    });
    // Vanaf nu doet dit script de knop en het verzenden; het vangnet in buy-buttons en het script in banky-bis-terugval stoppen.
    window.bankyProduct.bis = true;
  }

  /* ---- Lade meteen open bij toevoegen (koopvak en sticky balk) ----------------------------------------------------
     Geert 02-10: "bij toevoegen laad die langzaam". Halo opent de lade pas als cart/add.js én daarna een los /cart.js
     klaar zijn (live gemeten 02-10, iPhone 14: 0,6 tot 0,9 s na de tik, met 4G-vertraging 0,8 tot 1,0 s) en speelt dan
     nog 0,7 s animatie af. Nu gaat de lade open zodra Halo's productformulier het verzoek verstuurt, met een laadstaat
     (data-banky-laden en aria-busy, opmaak in banky-cart-drawer): animatie en netwerk lopen tegelijk. De klant ziet meteen
     de overlay en het inschuivende paneel; Halo toont de inhoud pas na ruim een halve seconde, dus de laadring is meestal
     maar kort of niet te zien. Halo's eigen variant:add en cart:change vullen de lade zoals altijd (show() doet niets als
     hij al open is). Bij cart:error gaat de lade direct dicht en komt Halo's melding boven de koopknop in beeld; na 15 s
     zonder antwoord gaat hij ook dicht. Niet bij Direct afrekenen (banky-cards.js stuurt dan door naar /checkout) en niet
     in de snelkooplade (dat formulier hoort niet bij een koopbox). */
  function snelleLade() {
    const settings = (window.themeVariables && window.themeVariables.settings) || {};
    if (settings.cartType !== 'drawer' || settings.pageType === 'cart') return;
    const lade = () => document.querySelector('cart-drawer');
    let klok = null;
    const klaar = () => {
      clearTimeout(klok);
      const d = lade();
      if (d) { d.removeAttribute('data-banky-laden'); d.removeAttribute('aria-busy'); }
    };
    // Animaties van de lade zelf en van zijn shadow DOM (inhoud, sluitknop), voor het afronden bij een fout.
    const animaties = d => new Set([
      ...(d.getAnimations ? d.getAnimations({subtree: true}) : []),
      ...(d.shadowRoot && d.shadowRoot.getAnimations ? d.shadowRoot.getAnimations() : []),
    ]);
    document.addEventListener('submit', e => {
      const form = e.target;
      // Alleen als Halo's productformulier het verzoek nu zelf verstuurt. Halo's luisteraar zit op het formulier en is dus
      // al geweest: preventDefault gedaan en, pas na zijn geldigheidscontrole, de verzendknoppen op disabled én aria-busy
      // (CustomButton zet aria-busy ook bij een ongeldig formulier, disabled niet).
      if (!(form instanceof HTMLFormElement) || !e.defaultPrevented || !form.matches('form[is="product-form"]')) return;
      if (![...form.elements].some(b => b.type === 'submit' && b.hasAttribute('disabled') && b.getAttribute('aria-busy') === 'true')) return;
      if (!form.checkValidity()) return;
      const id = form.getAttribute('id') || '';
      if (!id || !perForm('[data-banky-koopbox][data-form="%"]', id).length) return;
      if (e.submitter && e.submitter.matches('[data-banky-direct-checkout]')) return;
      const d = lade();
      if (!d || typeof d.show !== 'function') return;
      d.setAttribute('data-banky-laden', '');
      d.setAttribute('aria-busy', 'true');
      clearTimeout(klok);
      klok = setTimeout(() => { const open = lade()?.hasAttribute('data-banky-laden'); klaar(); if (open) lade()?.hide?.(); }, 15000);
      d.show();
    });
    // Halo zet bij een lade die al regels had de nieuwe regels met setTimeout(0) (cart-drawer.js); daarna pas tonen.
    document.addEventListener('cart:change', () => setTimeout(klaar, 0));
    document.addEventListener('cart:error', e => {
      const d = lade();
      if (!d || !d.hasAttribute('data-banky-laden')) return;
      klaar();
      // Toets 02-10: Halo's sluitanimatie (tot 0,7 s) meteen afronden, zodat de melding bij de koopknop direct leesbaar
      // is en de koopknop bij een fout niet later reageert dan zonder deze lade. Alleen de animaties die hide() start.
      const al = animaties(d);
      d.hide?.();
      animaties(d).forEach(a => { if (!al.has(a)) { try { a.finish(); } catch { /* oneindige of al afgebroken animatie */ } } });
      const id = e.target instanceof HTMLFormElement ? e.target.getAttribute('id') || '' : '';
      const knoppen = id ? perForm('buy-buttons[form="%"]', id)[0] : null;
      if (!knoppen) return;
      const r = knoppen.getBoundingClientRect();
      if (r.top < 0 || r.bottom > innerHeight) knoppen.scrollIntoView({block: 'center', behavior: vloeiend() ? 'smooth' : 'auto'});
    });
    addEventListener('pageshow', e => { if (e.persisted) klaar(); });
  }

  /* ---- Duo knop: "1 stuk" of "2 stuks" in de koopbox -----------------------------------------------------------------
     Geert 19-10-2026: "bij alle producten een duo knop ... hoeveel ze daarop besparen ... het gaat dus aan de logica niet qua
     bundel maar bieden het qua tekst wel zo aan omdat dan automatisch de 20% korting word toegepast". Bouwplan en voorstel:
     /Users/geert/banky-r1-werk/duo-knop/BOUWPLAN.md en voorstel/assets/duo/duo.js. Markup: snippets/banky-duo-keuze.liquid.
     Technisch is "2 stuks" gewoon aantal 2; NAJAARSDEALS geeft zelf 20% op het 2e stuk.
       - tegel 2: 2 x stukprijs min wat het 2e stuk extra aan korting oplevert (marge, met de winkelwagen erbij en dezelfde
         regel als Maak het compleet, window.bankyDeal); pil "Bespaar €x" vanaf de van-prijs (2 x van-prijs min tegel 2, sinds
         31-10-2026; daarvoor de marge als "Extra korting €x"); regel "2e stuk 20% extra" als de marge
         precies 20% van dit stuk is, anders "Extra korting met je winkelwagen"; zonder marge geen pil en geen regel;
       - kiezen zet het gewone veld quantity van het productformulier op 1 of 2 (Maak het compleet rekent mee); het aantal
         zelf aanpassen zet de keuze mee (bij 3 of meer geen tegel gekozen); de knop volgt ("In winkelwagen", "2 in
         winkelwagen"), ook na Halo's variantwissel (BuyButtons zet de tekst terug, dit blok luistert later op hetzelfde
         formulier);
       - variant: de bedragen volgen de gekozen variant; kan die geen 2 leveren, dan is tegel 2 niet te kiezen en gaat 2 terug
         naar 1;
       - sticky balk: bij 2 stuks de duoprijs, "2 stuks" en de pil, de knop "2 in winkelwagen";
       - prijsgroepen (Geert 20-10-2026, korting "2e stuk zelfde prijs €x"): 2 stuks krijgen samen de 20% op het 2e stuk, ook
         met een goedkoper artikel in de wagen (dat verliest dan zijn 20%); de marge toont dat voordeel (data.gr, de prijzen
         van het product; data.groepen voor een winkelwagen uit /cart.js);
       - kiezen verschuift de pagina niet (het script kiest zelf en focust zonder scrollen); na een klik of tik geen focusrand,
         met het toetsenbord wel (html.banky-wijzer in assets/banky-cart.js). */
  function duoKnop() {
    document.querySelectorAll('[data-banky-duo]').forEach(blok => {
      if (blok.dataset.bankyKlaar) return;
      blok.dataset.bankyKlaar = '1';
      let data;
      try { data = JSON.parse(blok.querySelector('[data-banky-duo-data]').textContent); } catch { return; }
      const F = CSS.escape(blok.dataset.form || '');
      const T = data.tekst || {};
      const geldD = c => geld(c, data.geld);
      const vul = (s, w) => String(s || '').replace(/\{(\w+)\}/g, (m, k) => (k in w ? w[k] : m));
      const zet = (el, t) => { if (el && el.textContent !== t) el.textContent = t; };
      const veld = () => document.querySelector(`input[name="quantity"][form="${F}"]`);
      const radios = [...blok.querySelectorAll('.banky-duo__radio')];
      const r1 = radios.find(r => r.value === '1'), r2 = radios.find(r => r.value === '2');
      if (!r1 || !r2) return;
      const knop = () => document.querySelector(`buy-buttons[form="${F}"] button[type="submit"]`);
      const sticky = document.querySelector(`product-quick-add[form="${F}"]`);
      const stickyKnop = sticky && sticky.querySelector('[data-banky-sticky-knop]');
      const stickyDuo = sticky && sticky.querySelector('[data-banky-duo-sticky]');
      let variant = data.varianten.find(v => v.id === data.gekozen) || data.varianten[0];
      let wagen = data.wagen || [];
      const aantal = () => { const n = parseInt(veld()?.value, 10); return Number.isFinite(n) && n > 0 ? n : 1; };

      function cijfers(v) {
        const D = window.bankyDeal, p = v.p;
        // bespaar: de pil "Bespaar €x" vanaf de van-prijs (Geert 31-10-2026: "altijd vanaf de van-prijs hoogste korting laten
        // zien"): 2 x de van-prijs (v.c) min tegel 2, dus de gewone korting op beide stuks plus wat het 2e stuk extra krijgt.
        const c2 = 2 * (Number(v.c) > p ? Number(v.c) : p);
        const uit = {p1: p, p2: 2 * p, marge: 0, schoon: false, pct: 0, bespaar: Math.max(0, c2 - 2 * p)};
        if (!D) return uit;
        const inst = D.leesInstelling(data.deal);
        // Voordeel per paar brillen (20-10-2026, snippets/banky-bril-paar.liquid): brillen in de wagen rekenen zoals Shopify.
        const paar = Number(data.duoPaar) || 0;
        const {stukken, binnen} = D.stukkenUit(wagen, {}, inst.titel, inst.groepTitel, data.groepen || {});
        // zoals de lade en Maak het compleet: alleen als de winkelwagen nu rekent zoals de regel (vangnet)
        if (!inst.aan || !data.geldt || !D.dealKlopt(stukken, binnen, inst.pct, paar, inst.groepen)) return uit;
        const v0 = stukken.reduce((m, x) => Math.max(m, x.volg), -1) + 1;
        // gr: de prijsgroepen van het product (alle variantprijzen, snippets/banky-deal-groep.liquid). Prijsgroepen (Geert
        // 20-10-2026): 2 stuks van dit product krijgen samen de 20% op het 2e stuk, ook met een goedkoper artikel in de wagen.
        // v en d (Geert 21-10-2026): heeft de variant een geldige verborgen bundel van 2 stuks (d, snippets/banky-duo-paar.liquid),
        // dan worden de 2 stuks die bundel (deal: vast de x% op één stuk, buiten de actie); v telt mee met dezelfde variant in de wagen.
        const h = i => ({id: 'h', p, c: v.c || p, volg: v0 + i, g: true, bril: false, gr: data.gr, v: v.id, d: Number(v.d) === 1});
        // Geert 20-10-2026 (optie A, "Ah zo, ja doe A"): de pil toont wat 2 stuks aan korting aan de huidige wagen toevoegen, dus
        // de 20% op het 2e stuk (bijvoorbeeld kabel in de wagen plus 2 powerbanks 50.000: "2 stuks €89,91, Bespaar €9,99"), en
        // tegel 2 is precies wat het wagentotaal stijgt. Niet meer de marge tegenover 1 stuk (dat gaf €93,50 en €6,40).
        // Korting = de x% en de duoprijs samen: wint met de 2 stuks een prijsgroep, dan vervalt de duoprijs van brillen in de wagen
        // (20-10-2026; zonder groepen verandert de duoprijs hier nooit, het product is geen bril).
        const korting = s => { const d = D.deal(s, inst.pct, paar, inst.groepen); return d.tot + d.duo; };
        const d0 = stukken.length ? korting(stukken) : 0;
        const d2 = korting([...stukken, h(0), h(1)]);
        uit.marge = Math.max(0, d2 - d0);
        uit.p2 = 2 * p - uit.marge;
        uit.bespaar = Math.max(0, c2 - uit.p2);
        uit.pct = inst.pct;
        uit.schoon = uit.marge > 0 && uit.marge === Math.round(p * inst.pct / 100);
        return uit;
      }
      function knoppen(c) {
        const n = aantal(), duo = n === 2 && !r2.disabled;
        const b = knop();
        if (b && !b.disabled) {
          const tekstEl = (b.getAttribute('is') === 'custom-button' && b.firstElementChild) || b;
          zet(tekstEl, n === 1 ? T.knop : vul(T.knopN, {n}));
          if (duo) b.setAttribute('aria-label', vul(T.knopNaam, {naam: `${T.twee}, ${geldD(c.p2)}`})); else b.removeAttribute('aria-label');
        }
        if (stickyKnop && !stickyKnop.disabled) {
          zet(stickyKnop, n === 1 ? T.knop : vul(T.knopN, {n}));
          if (duo) stickyKnop.setAttribute('aria-label', vul(T.knopNaam, {naam: `${T.twee}, ${geldD(c.p2)}`})); else stickyKnop.removeAttribute('aria-label');
        }
        if (sticky) {
          if (duo) sticky.dataset.bankyDuoAantal = '2'; else delete sticky.dataset.bankyDuoAantal;
          if (stickyDuo) {
            stickyDuo.hidden = !duo;
            zet(stickyDuo.querySelector('[data-banky-duo-sticky-prijs]'), geldD(c.p2));
            const sp = stickyDuo.querySelector('[data-banky-duo-sticky-voordeel]');
            if (sp) { zet(sp, vul(T.voordeel, {bedrag: geldD(c.bespaar)})); sp.hidden = !(c.bespaar > 0); }
          }
        }
        blok.dataset.aantal = String(n);
      }
      function syncKeuze() {
        const n = aantal();
        const een = n === 1, twee = n === 2 && !r2.disabled;
        if (r1.checked !== een) r1.checked = een;
        if (r2.checked !== twee) r2.checked = twee;
      }
      function zetAantal(n) {
        const v = veld();
        if (!v || String(n) === v.value) return;
        v.value = String(n);
        // Maak het compleet (BankyComplete) rekent mee op input en change van dit veld.
        v.dispatchEvent(new Event('input', {bubbles: true}));
        v.dispatchEvent(new Event('change', {bubbles: true}));
      }
      function toon() {
        const c = cijfers(variant);
        const kan = !!variant.duo;
        r2.disabled = !kan;
        zet(blok.querySelector('[data-banky-duo-prijs="1"]'), geldD(c.p1));
        zet(blok.querySelector('[data-banky-duo-prijs="2"]'), geldD(c.p2));
        const pil = blok.querySelector('[data-banky-duo-voordeel]');
        if (pil) pil.hidden = !(kan && c.bespaar > 0);
        zet(blok.querySelector('[data-banky-duo-voordeel-tekst]'), vul(T.voordeel, {bedrag: geldD(c.bespaar)}));
        const sub = blok.querySelector('[data-banky-duo-sub]');
        const subTekst = !kan ? T.subGeen : c.schoon ? vul(T.sub, {pct: c.pct}) : c.marge > 0 ? T.subWagen : '';
        zet(blok.querySelector('[data-banky-duo-sub-tekst]'), subTekst || '');
        if (sub) sub.hidden = !subTekst;
        if (!kan && aantal() === 2) zetAantal(1);
        syncKeuze();
        knoppen(c);
      }
      const kies = n => { zetAantal(n); toon(); };

      // Kiezen zonder sprong: het script kiest zelf en focust zonder scrollen.
      blok.addEventListener('change', e => {
        const r = e.target.closest('.banky-duo__radio');
        if (r && r.checked) kies(Number(r.value));
      });
      blok.querySelectorAll('label.banky-duo__optie').forEach(l => l.addEventListener('click', e => {
        const r = document.getElementById(l.htmlFor);
        if (!r || e.target === r) return;
        e.preventDefault();
        if (r.disabled) return;
        if (!r.checked) r.click();
        r.focus({preventScroll: true});
      }));
      // Het aantal zelf aanpassen: Halo's aantalknoppen zetten de waarde zonder input-gebeurtenis, de klik bubbelt wel.
      veld()?.closest('quantity-selector')?.addEventListener('click', () => requestAnimationFrame(toon));
      veld()?.addEventListener('input', e => { if (e.isTrusted) toon(); });
      veld()?.addEventListener('change', e => { if (e.isTrusted) toon(); });
      // Variantwissel: na Halo (BuyButtons luistert eerder op hetzelfde formulier en zet de knoptekst terug).
      const form = document.forms[blok.dataset.form] || document.getElementById(blok.dataset.form);
      form?.addEventListener('variant:change', e => {
        const id = e.detail && e.detail.variant && e.detail.variant.id;
        const v = data.varianten.find(x => x.id === Number(id));
        if (v) variant = v;
        // De foto's in de tegel 2 stuks volgen de gekozen kleur (Geert 21-10-2026: bij wit alleen witte foto's).
        const m = e.detail && e.detail.variant && e.detail.variant.featured_media;
        const bron = m && m.preview_image && m.preview_image.src;
        if (bron) blok.querySelectorAll('.banky-duo__beeld img').forEach(img => {
          const u = new URL(bron, location.href); u.searchParams.set('width', '72');
          if (img.src !== u.href) { img.removeAttribute('srcset'); img.src = u.href; }
        });
        toon();
      });
      document.addEventListener('cart:change', e => { const c = e.detail && e.detail.cart; if (c && Array.isArray(c.items)) { wagen = c.items; toon(); } });
      toon();
      // Duo-bundels (Geert 21-10-2026): de link naar een verborgen bundel van 2 stuks komt hier met ?pakket=duo
      // (snippets/banky-product-url.liquid, layout/doorsturen.liquid); dan staat 2 stuks gekozen.
      if (/[?&]pakket=duo(&|$)/.test(location.search) && !r2.disabled) kies(2);
    });
  }

  // Toets 06-10: een fout in één onderdeel houdt de andere (zoals het voorraadformulier) niet tegen; de fout blijft zichtbaar in de console.
  const start = () => [titelEenheden, volgFormulieren, sticky, bisTerugval, snelleLade, duoKnop].forEach(f => {
    try { f(); } catch (fout) { setTimeout(() => { throw fout; }); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* ---- Klarna pas bij eerste interactie (snelheidsronde 2, Geert 05-10-2026: "de rest sws alles uitvoeren wat sneller maakt") ----
   Het Klarna-blok in de koopbox staat in een <template> (snippets/product-info.liquid). Bij de eerste scroll, aanraking, toets of
   muisbeweging zet dit blok het in de pagina, in een rustig moment (requestIdleCallback, uiterlijk na 1 s), zodat die eerste
   aanraking zelf niet trager wordt. Het ingevoegde script meldt de plaatsing bij Klarna's index.js (klarnaAppBlocksManager), dat
   daarna klarna.js laadt en het bericht toont; de variantwissel volgt Klarna zelf (MutationObserver op ?variant=). De taal staat
   meteen op nl-NL, zoals de terugval in layout/theme.liquid voor plaatsingen die bij het laden al in de pagina staan. De plek
   houdt de hoogte van het bericht vrij (banky-pagina-product.css), dus het invoegen verschuift niets.
   Geert 20-10-2026 ("ik zou trouwens dat de klarna sectie op de product pagina langzaam laad"): niet meer wachten op een interactie,
   maar ook direct na het laden van de pagina (load, dan het eerstvolgende rustige moment), wat het eerst komt; de kop maakt op
   productpagina's al vroeg verbinding met Klarna (layout/theme.liquid). De plek houdt de hoogte vrij, het bericht volgt circa een halve
   seconde na het laden (gemeten 20-10: 0,4 tot 0,55 s, was zonder interactie nooit). */
(() => {
  const plekken = () => document.querySelectorAll('.banky-klarna-plek[data-banky-klarna]');
  if (!plekken().length) return;
  const SIGNALEN = ['scroll', 'wheel', 'touchstart', 'pointerdown', 'pointermove', 'mousemove', 'keydown', 'focusin'];
  let gestart = false;
  const zetIn = () => {
    plekken().forEach(plek => {
      const t = plek.querySelector(':scope > template');
      plek.removeAttribute('data-banky-klarna');
      if (!t) return;
      const inhoud = document.importNode(t.content, true);
      inhoud.querySelectorAll('klarna-placement').forEach(k => k.setAttribute('data-locale', 'nl-NL'));
      t.replaceWith(inhoud);
    });
  };
  const start = () => {
    if (gestart) return;
    gestart = true;
    SIGNALEN.forEach(s => removeEventListener(s, start, {capture: true}));
    if ('requestIdleCallback' in window) requestIdleCallback(zetIn, {timeout: 1000}); else setTimeout(zetIn, 200);
  };
  SIGNALEN.forEach(s => addEventListener(s, start, {capture: true, passive: true}));
  if (document.readyState === 'complete') start(); else addEventListener('load', start, {once: true});
})();
